import React, {
  MutableRefObject,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CalenderIcon from "../../../../svg/Ads_Dashboard_Developement2/CalenderIcon/elements.svg";
import FullScreenIcon from "../../../svg/Ads_Dashboard_Developement2/FullScreenIcon/elements.svg";
import ExportIcon from "../../../../svg/Ads_Dashboard_Developement2/ExportIcon/elements.svg";
import ThreeDotIcon from "../../../../svg/Ads_Dashboard_Developement2/ThreeDotIcon/elements.svg";
import DragAndDropIcon from "../../../../svg/Ads_Dashboard_Developement2/Drag_and_Drop_Icon/elements.svg";
import GraphIcon from "../../../../svg/Ads_Dashboard_Developement2/GraphIcon/elements.svg";
import { addDays, endOfMonth, subMonths } from "date-fns";
import CompareTwoDateRangeComponent from "../../../commonComponents/ComparisonDateRangeComponent/CompareTwoDateRangeComponent 1";
import {
  Button,
  CircularProgress,
  DialogContent,
  Drawer,
  Input,
  Option,
  Select,
  selectClasses,
  Switch,
} from "@mui/joy";
import { BASE_URL, BLACK, WHITE } from "../../../../appConstants";
import CondCmpForDbData from "../../../commonComponents/Ads_Dashboard_Cmps/Comparison Components/Condition Comparison Component/CondCmpForDbData";
import CondCmpForCreate from "../../../commonComponents/Ads_Dashboard_Cmps/Comparison Components/Condition Comparison Component/CondCmpForCreate";
import { useSelector } from "react-redux";
import axios from "axios";
import appError from "../../../../appError";
import toast from "react-hot-toast";
import PaginationComponent from "../../../commonComponents/PaginationComponent";
import { debounce } from "lodash";
import MultiSelectFilter from "../MultiSelectFilter";
import MultiSelectFilterComponent from "../MultiSelectFilterComponent";
import { convertTotalData, downloadCSV, transformToComparisonTable } from "../../../../appFunctions";
import ComparisonExportModal from "../../../commonComponents/Ads_Dashboard_Cmps/Comparison Components/Export Functionality/ComparisonExportSelectionModal";
import ComparisonTableEmpty from "../../../commonComponents/Ads_Dashboard_Cmps/Comparison Components/Comparison Table/ComparisonTableEmpty";
import UpdatedComparisonTable from "../../../commonComponents/Ads_Dashboard_Cmps/Comparison Components/Comparison Table/UpdatedComparisonTable";
import ConfirmConditionModal from "../../../commonComponents/Ads_Dashboard_Cmps/Comparison Components/Condition Comparison Component/ConfirmConditionModal";
import CreateNewConditionModal from "../../../commonComponents/Ads_Dashboard_Cmps/Comparison Components/Condition Comparison Component/CreateNewConditionModal";
import ConditionCompCmp from "../../../commonComponents/Ads_Dashboard_Cmps/Comparison Components/Condition Comparison Component/ConditionCompCmp";
import ComparisonExportSelectionModal from "../../../commonComponents/Ads_Dashboard_Cmps/Comparison Components/Export Functionality/ComparisonExportSelectionModal";
import ComparisonCustomExportModal from "../../../commonComponents/Ads_Dashboard_Cmps/Comparison Components/Export Functionality/ComparisonCustomExportModal";

type DateProps = {
  startDate: Date;
  endDate: Date;
};
type Range = {
  rangeOne: DateProps;
  rangeTwo: DateProps;
};
type IpDate = {
  rangeOne: DateProps;
  rangeTwo: DateProps;
};
type RangeProps = {
  min_date: Date;
  max_date: Date;
};
type SearchObjProps = {
  value: string;
  frontend_value_type: string;
  backend_value_type: string;
};
type Matrice = {
  id: number;
  matrice_name: string;
  backend_matrice_name: string;
  toggle: boolean;
  position: number;
};
type Parameter = {
  id: number;
  parameter_name: string;
  backend_parameter_name: string;
  toggle: boolean;
  position: number;
};
type ProductDetailsProps = {
  id: number;
  detail_name: string;
  backend_name: string;
  toggle: boolean;
  position: number;
};
type Condition = {
  metric: string;
  parameter: string;
  // operator?: string;
  initial_value: string;
  dependent_value: string;
  Operation: string;
};
type MatricsProps = {
  id: number;
  matrice_name: string;
  backend_matrice_name: string;
};
type ParametersProps = {
  id: number;
  parameter: string;
};
type OperationProps = {
  id: number;
  operation: string;
};
type NewConditionProps = {
  metric: string;
  metric_error?: boolean;
  parameter: string;
  parameter_error?: boolean;
  Operation: string;
  Operation_error?: boolean;
  initial_value: string;
  initial_value_error?: boolean;
  dependent_value: string;
};
type ListProps = {
  condition_name: string;
  condition_array: Condition[];
  condition_id: string;
  dashboard: string;
};
type SortProps = {
  metric: string;
  sort_by: string;
  direction: string;
};
type MetricsHeaderDataProps = {
  headerName: string;
  field: string;
};
type SearchObjArr = {
  detail_name: string;
  backend_name: string;
};
type SearchDataArrProps = {
  value: string;
};
type MetricData = {
  current: string | undefined;
  previous: string | undefined;
  difference: string | undefined;
  difference_percentage: string | undefined;
};
type RowData = { [key: string]: MetricData };
type All_CategoriesProps = {
  ad_type: SearchDataArrProps[];
  campaign_name: SearchDataArrProps[];
  placementclassification: SearchDataArrProps[];
  [key: string]: SearchDataArrProps[]; // <-- Add this to allow indexing
};
type All_Sel_CategoriesProps = {
  ad_type: string[];
  campaign_name: string[];
  placementclassification: string[];
  [key: string]: string[]; // Allows dynamic indexing
};

type FilterButtonProps = {
  id: string;
  label: string;
};
type PaginationProps = {
  limit : number,
  page: number
}

const PlacementAnalysisComparison = () => {
  const [productDetails, setProductDetails] = useState<ProductDetailsProps[]>(
    []
  );

  const [parametersData, setParametersData] = useState<Parameter[]>([]);

  const [matricesData, setMatricesData] = useState<Matrice[]>([]);

  // For Drawer
  const [productDetailsDrawer, setProductDetailsDrawer] = useState<ProductDetailsProps[]>([]);

  const [parametersDataDrawer, setParametersDataDrawer] = useState<Parameter[]>([]);

  const [matricesDataDrawer, setMatricesDataDrawer] = useState<Matrice[]>([]);

  // For Selected Product Details Only
  const [sel_productDetails, setSel_ProductDetails] = useState<
    ProductDetailsProps[]
  >([]);

  const onDrillUpHandler = () => {
    // Get selected backend_names from product details
    const selectedProductTypes = productDetails
      .filter((product_detail_column) => product_detail_column?.toggle)
      .map((obj) => obj?.backend_name);

    // Sort selected types based on hierarchy order
    const sortedSelectedTypes = hierarchy.filter((type) =>
      selectedProductTypes.includes(type)
    );

    // Get the last selected type
    const lastSelectedType =
      sortedSelectedTypes[sortedSelectedTypes.length - 1];

    // Find the previous type in the hierarchy
    const lastSelectedIndex = hierarchy.indexOf(lastSelectedType);
    const countProductDetails = productDetails.filter((item) => item?.toggle);
    const prevType =
      lastSelectedIndex > 0 && countProductDetails.length > 1
        ? hierarchy[lastSelectedIndex - 1]
        : undefined;

    if (
      sel_categories[lastSelectedType] &&
      Array.isArray(sel_categories[lastSelectedType]) &&
      sel_categories[lastSelectedType].length > 0
    ) {
      setSel_Categories((prevState) => ({
        ...prevState,
        [lastSelectedType]: [],
      }));
      setSel_CategoriesDrawer((prevState) => ({
        ...prevState,
        [lastSelectedType]: [],
      }));
    }
    // ✅ Edge case: If the first column is already selected, log message **only once**
    if (!prevType) {
      toast.error("Minimum 1 Product Detail to be present");
      return; // Stop execution here
    }

    // ✅ Update Product Details State (disable last selected)
    setProductDetails((prev) => {
      let updated_product_details = prev.map((item) =>
        item?.backend_name === lastSelectedType
          ? { ...item, toggle: false }
          : item
      );
      setSel_ProductDetails(
        updated_product_details?.filter(
          (product_detail) => product_detail?.toggle === true
        )
      );
      setProductDetailsDrawer(updated_product_details);
      updateColumns(updated_product_details, "PRODUCT_DETAILS", [], [], true);
      fetchTableData(updated_product_details, matricesData, hierarchy, matrices_hierarchy);
      fetchTotalData(updated_product_details, matricesData);
      return updated_product_details;
    });

    // ✅ Update Selected Headers State (remove last header)
    setSel_headers((prev) =>
      prev.filter((header) => header.type !== lastSelectedType)
    );
  };

  const onDrillDownHandler = () => {
    // Get selected backend_names from product details
    const selectedProductTypes = productDetails
      .filter((product_detail_column) => product_detail_column?.toggle)
      .map((obj) => obj?.backend_name);

    // Get selected headers
    const selectedHeaderTypes = sel_headers.map((header) => header.type);

    // Sort selected types based on hierarchy order
    const sortedSelectedTypes = hierarchy.filter((type) =>
      selectedProductTypes.includes(type)
    );

    // Get the last selected type
    const lastSelectedType =
      sortedSelectedTypes[sortedSelectedTypes.length - 1];

    // Find the next type in the hierarchy
    const lastSelectedIndex = hierarchy.indexOf(lastSelectedType);
    const nextType =
      lastSelectedIndex !== -1 ? hierarchy[lastSelectedIndex + 1] : undefined;

    // ✅ Edge case: If last column is already selected, log message **only once**
    if (!nextType) {
      toast.error("No more product details to add.");
      return; // Stop execution here
    }

    // ✅ Update Product Details State
    setProductDetails((prev) => {
      let updated_product_details = prev.map((item) =>
        item?.backend_name === nextType ? { ...item, toggle: true } : item
      );
      setSel_ProductDetails(
        updated_product_details?.filter(
          (product_detail) => product_detail?.toggle === true
        )
      );
      setProductDetailsDrawer(updated_product_details);
      updateColumns(updated_product_details, "PRODUCT_DETAILS", [], [], true);
      fetchTableData(updated_product_details, matricesData,hierarchy, matrices_hierarchy);
      fetchTotalData(updated_product_details, matricesData);
      return updated_product_details;
    });

    // ✅ Update Selected Headers State
    setSel_headers((prev) => {
      // Find the corresponding object in initial_header_data
      const nextHeader = initial_header_data.find(
        (header) => header.type === nextType
      );
      return nextHeader ? [...prev, nextHeader] : prev;
    });
  };

  const navigate = useNavigate();
  const location = useLocation();
  const { brand_id } = useParams();
  const { platform_id } = useSelector((state: any) => state.appData);
  const [range, setRange] = useState<RangeProps>({} as RangeProps);
  const [hierarchy_levels, setHierarchy_levels] = useState<number>(0);

  const getWeekRange = (date: Date) => {
    const todayDate = date.getDate();

    // Define fixed week ranges
    const weeks: [number, number][] = [
      [1, 7],
      [8, 14],
      [15, 21],
      [22, 28],
      [29, 31],
    ];

    // Find the index of the current week
    const currentWeekIndex = weeks.findIndex(
      ([start, end]) => todayDate >= start && todayDate <= end
    );
    if (currentWeekIndex === -1) return null; // Fallback in case no match is found

    // Get the current and previous week's range
    const [currentStart, currentEnd] = weeks[currentWeekIndex];

    let prevStart, prevEnd, month, year;
    if (currentStart === 1 && currentEnd === 7) {
      const lastMonthDate = subMonths(date, 1);
      const prevMonthLastDate = endOfMonth(lastMonthDate)?.getDate();

      const prevWeek = weeks.find(
        ([start, end]) => prevMonthLastDate >= start && prevMonthLastDate <= end
      );
      prevStart = prevWeek?.[0];
      prevEnd = endOfMonth(lastMonthDate)?.getDate();
      month = lastMonthDate?.getMonth();
      year = lastMonthDate?.getFullYear();
    } else {
      const lastweek = weeks[currentWeekIndex - 1] || [1, 7]; // Default to first week if no previous
      prevStart = lastweek?.[0];
      prevEnd = lastweek?.[1];
      month = date?.getMonth();
      year = date?.getFullYear();
    }

    return {
      previousWeekStart: new Date(year, month, prevStart),
      previousWeekEnd: new Date(year, month, prevEnd),
      currentWeekStart: new Date(
        date?.getFullYear(),
        date?.getMonth(),
        currentStart
      ),
    };
  };

  // Get today's date and week range
  const today = new Date();

  const [InputRange, setInputRange] = useState<Range>({
    // ------- Input
    rangeOne: {
      // Current Date
      startDate: today,
      endDate: today,
    },
    rangeTwo: {
      // Comparison Date
      startDate: today,
      endDate: today,
    },
  });

  const [pagination, setPagination] = useState<PaginationProps>({
    limit: 50,
    page: 1
  });
  const [maxCount, setMaxCount] = useState<number>(0);

  const [valueFilter, setValueFilter] = useState<string>("VALUE"); // -------- Input   // Value OR Share % OR AVERAGE
  const [searchobj, setSearchObj] = useState<SearchObjProps>({
    // -------- Input
    value: "",
    frontend_value_type: "Campaign Name",
    backend_value_type: "campaign_name",
  });

  const [conditionsArr, setConditionsArr] = useState<Condition[]>([]); //---------- Input
  
  // Arrays for All Product Details Columns in Table
  const [categories, setCategories] = useState<All_CategoriesProps>({
    ad_type: [],
    campaign_name: [],
    placementclassification: [],
  });

  // Object for All Selected Categories
  const [sel_categories, setSel_Categories] = useState<All_Sel_CategoriesProps>(
    {
      ad_type: [],
      campaign_name: [],
      placementclassification: [],
    }
  );

  const [sel_categoriesdrawer, setSel_CategoriesDrawer] = useState<All_Sel_CategoriesProps>(
    {
      ad_type: [],
      campaign_name: [],
      placementclassification: [],
    }
  );

  const [sort, setSort] = useState<SortProps>({
    // ------ Input
    metric: "",
    sort_by: "current",
    direction: "",
  });

  const [sel_metricsHeaderData, setSel_metricsHeaderData] = useState<
    MetricsHeaderDataProps[]
  >([]);

  const [resultDataArr, setResultDataArr] = useState<any[]>([]);
  const [metrics_row_data, setMetrics_row_data] = useState<any[]>([]); 
  const [loading, setLoading] = useState<boolean>(false); // Loader for Table
  const [datafetchingState, setDataFetchingState] = useState<string>("");

  type header = {
    title_name: string;
    type: string;
    width: number;
  };
  const [initial_header_data, setInitial_Header_Data] = useState<header[]>([]);

  const [sel_headers, setSel_headers] = useState<header[]>([]);

  const filterHeaderData = (
    hierarchy: string[],
    initialHeaderData: header[],
    presentHeaderData: string[]
  ): header[] => {
    // Filter the hierarchy to include only types present in presentHeaderData
    const filteredHierarchy = hierarchy.filter((type) =>
      presentHeaderData.includes(type)
    );

    // Map the filtered hierarchy to corresponding header objects from initialHeaderData
    return filteredHierarchy
      .map((type) => initialHeaderData.find((header) => header.type === type))
      .filter((header): header is header => header !== undefined); // Remove any undefined values in case of mismatch
  };

  // Hierarchy for Product Details
  const [hierarchy, setHierarchy] = useState<string[]>([]);

  // hierarchy for matrices
  const [matrices_hierarchy, setMatrices_hierarchy] = useState<string[]>([]);

  // hierarchy for parameters
  const [parameters_hierarchy, setParameters_hierarchy] = useState<string[]>(
    []
  );

  const [positive_values, setPositive_Values] = useState([
    "impressions",
    "clicks",
    "sales",
    "orders",
    "units",
    "ctr",
    "cvr",
    "aov",
    "roas",
  ]);

  const [negative_values, setNegative_Values] = useState([
    "spend",
    "acos",
    "cpc",
  ]);

  const [Total_data, setTotal_data] = useState<any[]>([]); // Atlast assign empty array
  const [sel_parameters, setSel_Parameters] = useState<string[]>([]);
  const [exportToggle, setExportToggle] = useState<boolean>(false); 

  const exportHandler = async (ip_parameters: string[]) => {
    let sel_product_details = productDetails
      .filter((d) => d?.toggle === true)
      .map((item) => item?.backend_name);
    let sel_matrices = matricesData
      .filter((d) => d?.toggle === true)
      .map((item) => item?.backend_matrice_name);

    let temp_obj = {
      filter: {
        current_data_range: {
          start_date: `${InputRange?.rangeOne?.startDate?.getFullYear()}-${String(
            InputRange?.rangeOne?.startDate.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeOne?.startDate.getDate()
          ).padStart(2, "0")}`,

          end_date: `${InputRange?.rangeOne?.endDate?.getFullYear()}-${String(
            InputRange?.rangeOne?.endDate.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeOne?.endDate.getDate()
          ).padStart(2, "0")}`,
        },
        previous_data_range: {
          start_date: `${InputRange?.rangeTwo?.startDate?.getFullYear()}-${String(
            InputRange?.rangeTwo?.startDate.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeTwo?.startDate.getDate()
          ).padStart(2, "0")}`,

          end_date: `${InputRange?.rangeTwo?.endDate?.getFullYear()}-${String(
            InputRange?.rangeTwo?.endDate.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeTwo?.endDate.getDate()
          ).padStart(2, "0")}`,
        },
        product_detail_filter: Object.fromEntries(
          Object.entries(sel_categories).filter(
            ([_, value]) => value.length > 0
          )
        ),
      },
      conditions: conditionsArr.map((singleCondition) => ({
        metric: singleCondition?.metric,
        parameter: singleCondition?.parameter,
        operator: singleCondition?.Operation.toUpperCase(),
        initial_value: Number(singleCondition?.initial_value),
        dependent_value: Number(singleCondition?.dependent_value),
      })),
      sort: sort,
      product_detail_column: sel_product_details,
      metrics_column: sel_matrices,
    };

    const token = localStorage.getItem("token");
    try {
      setExportLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/placement/getPlacementComparasionOfTwoRange?brand_id=${brand_id}&limit=${maxCount}`;
      const result = await axios.post(api, temp_obj, { headers });
      const { results } = result?.data?.data;
      if (results?.length === 0) {
      } else if (results.length > 0) {

        // Preprocess once outside the map
        const sortedParams = [...ip_parameters].sort((a, b) => b.length - a.length);
        const regex = new RegExp(`^(.*)_(${sortedParams.join('|')})$`);

        // Pre-index matricesData and productDetails for O(1) lookup
        const matricesMap = Object.fromEntries(
          matricesData.map((item: any) => [item.backend_matrice_name, item.matrice_name])
        );

        const productDetailsMap = Object.fromEntries(
          productDetails.map((item: any) => [item.backend_name, item.detail_name])
        );

        const new_arr = results?.map((item: any) => {
          const new_obj: any = {};

          for (let key in item) {
            const match = key.match(regex);

            if (match) {
              const firstHalf = match[1]; // e.g., 'acos'
              const secondHalf = match[2]; // e.g., 'difference_percentage'

              const matriceName = matricesMap[firstHalf];
              if (matriceName) {
                new_obj[`${matriceName}_${secondHalf}`] = item[key];
              }
            } else if (key !== "total_count") {
              const detailName = productDetailsMap[key];
              if (detailName) {
                new_obj[detailName] = item[key];
              }
            }
          }

          return new_obj;
        });
      
      downloadCSV(new_arr, "PlacementComparisonData.csv");
      setExportSelectionToggle(false);
      }
    } catch (error) {
      appError(error);
    } finally {
      setExportLoading(false);
    }
  };
  const [exportLoading, setExportLoading] = useState<boolean>(false);
  
  const exportCustomHandler = async (ip_Range: Range, ip_productDetails: string[], ip_parameters: string[], ip_matrices: string[]) => {
    let temp_obj = {
      filter: {
        current_data_range: {
          start_date: `${ip_Range?.rangeOne?.startDate?.getFullYear()}-${String(
            ip_Range?.rangeOne?.startDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            ip_Range?.rangeOne?.startDate?.getDate()
          ).padStart(2, "0")}`,

          end_date: `${ip_Range?.rangeOne?.endDate?.getFullYear()}-${String(
            ip_Range?.rangeOne?.endDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            ip_Range?.rangeOne?.endDate?.getDate()
          ).padStart(2, "0")}`,
        },
        previous_data_range: {
          start_date: `${ip_Range?.rangeTwo?.startDate?.getFullYear()}-${String(
            ip_Range?.rangeTwo?.startDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            ip_Range?.rangeTwo?.startDate?.getDate()
          ).padStart(2, "0")}`,

          end_date: `${ip_Range?.rangeTwo?.endDate?.getFullYear()}-${String(
            ip_Range?.rangeTwo?.endDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            ip_Range?.rangeTwo?.endDate?.getDate()
          ).padStart(2, "0")}`,
        },
        product_detail_filter: {},
      },
      conditions: [],
      sort: {},
      product_detail_column: ip_productDetails,
      metrics_column: ip_matrices,
    };
    const token = localStorage.getItem("token");
    try {
      setExportLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/placement/getPlacementComparasionOfTwoRange?brand_id=${brand_id}&page=${0}&limit=${0}`;
      const result = await axios.post(api, temp_obj, { headers });
      const { results } = result?.data?.data;
      if (results?.length === 0) {
      } else if (results.length > 0) {
        // Preprocess once outside the map
        const sortedParams = [...ip_parameters].sort((a, b) => b.length - a.length);
        const regex = new RegExp(`^(.*)_(${sortedParams.join('|')})$`);

        // Pre-index matricesData and productDetails for O(1) lookup
        const matricesMap = Object.fromEntries(
          matricesData.map((item: any) => [item.backend_matrice_name, item.matrice_name])
        );

        const productDetailsMap = Object.fromEntries(
          productDetails.map((item: any) => [item.backend_name, item.detail_name])
        );

        const new_arr = results?.map((item: any) => {
          const new_obj: any = {};

          for (let key in item) {
            const match = key.match(regex);

            if (match) {
              const firstHalf = match[1]; // e.g., 'acos'
              const secondHalf = match[2]; // e.g., 'difference_percentage'

              const matriceName = matricesMap[firstHalf];
              if (matriceName) {
                new_obj[`${matriceName}_${secondHalf}`] = item[key];
              }
            } else if (key !== "total_count") {
              const detailName = productDetailsMap[key];
              if (detailName) {
                new_obj[detailName] = item[key];
              }
            }
          }

          return new_obj;
        });
      
      downloadCSV(new_arr, "PlacementComparisonData.csv");
      setCustomExportToggle(false);
      }
    } catch (error) {
      appError(error);
    } finally {
      setExportLoading(false);
    }
  };

  const fetchTableData = async (products_details_arr: ProductDetailsProps[], metrics_arr: Matrice[],product_details_hierarchy: string[], metrics_hierarchy: string[]) => {
    let sel_product_details = products_details_arr
      .filter((d) => d?.toggle === true)
      .map((item) => item?.backend_name);

    let metrics = metrics_arr
      .filter((m) => m?.toggle === true)
      .map((item) => item?.backend_matrice_name);

    let sel_metrices_for_header = metrics_arr
      .filter((m) => m?.toggle === true)
      .map((item) => ({
        headerName: item?.matrice_name,
        field: item?.backend_matrice_name,
      }))
      .sort(
        (a, b) =>
          metrics_hierarchy.indexOf(a.field) -
          metrics_hierarchy.indexOf(b.field)
      );

    let temp_obj = {
      filter: {
        current_data_range: {
          start_date: `${InputRange?.rangeOne?.startDate?.getFullYear()}-${String(
            InputRange?.rangeOne?.startDate.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeOne?.startDate.getDate()
          ).padStart(2, "0")}`,

          end_date: `${InputRange?.rangeOne?.endDate?.getFullYear()}-${String(
            InputRange?.rangeOne?.endDate.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeOne?.endDate.getDate()
          ).padStart(2, "0")}`,
        },
        previous_data_range: {
          start_date: `${InputRange?.rangeTwo?.startDate?.getFullYear()}-${String(
            InputRange?.rangeTwo?.startDate.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeTwo?.startDate.getDate()
          ).padStart(2, "0")}`,

          end_date: `${InputRange?.rangeTwo?.endDate?.getFullYear()}-${String(
            InputRange?.rangeTwo?.endDate.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeTwo?.endDate.getDate()
          ).padStart(2, "0")}`,
        },
        product_detail_filter: Object.fromEntries(
          Object.entries(sel_categories).filter(
            ([_, value]) => value.length > 0
          )
        ),
      },
      conditions: conditionsArr.map((singleCondition) => ({
        metric: singleCondition?.metric,
        parameter: singleCondition?.parameter,
        operator: singleCondition?.Operation.toUpperCase(),
        initial_value: Number(singleCondition?.initial_value),
        dependent_value: Number(singleCondition?.dependent_value),
      })),
      sort: sort,
      product_detail_column: sel_product_details,
      metrics_column: metrics,
    };

    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/placement/getPlacementComparasionOfTwoRange?brand_id=${brand_id}&page=${pagination?.page}&limit=${pagination?.limit}`;
      const result = await axios.post(api, temp_obj, { headers });
      const { results } = result?.data?.data;
      if (results?.length === 0) {
        setSel_headers(
          filterHeaderData(product_details_hierarchy, initial_header_data, sel_product_details)
        );
        setSel_metricsHeaderData(sel_metrices_for_header);
        setMaxCount(0);
        setDataFetchingState("EMPTY");
      } else if (results.length > 0) {
        setResultDataArr(
          transformToComparisonTable(
            results,
            product_details_hierarchy,
            sel_product_details,
            metrics_hierarchy,
            metrics
          )?.comparisonTableData
        );
        setMetrics_row_data(transformToComparisonTable(
                  results,
                  product_details_hierarchy,
                  sel_product_details,
                  metrics_hierarchy,
                  metrics
                )?.rows_data);

        setMaxCount(results[0]?.total_count);

        setSel_headers(
          filterHeaderData(product_details_hierarchy, initial_header_data, sel_product_details)
        );
        setSel_metricsHeaderData(sel_metrices_for_header);

        setDataFetchingState("SUCCESS");
      }
    } catch (error) {
      appError(error);
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetchData = useMemo(
    () => debounce(fetchTableData, 1000),
    [fetchTableData]
  );

  const fetchTotalData = async (products_details_arr: ProductDetailsProps[], metrics_arr: Matrice[]) => {
    let sel_product_details = products_details_arr
      .filter((d) => d?.toggle === true)
      .map((item) => item?.backend_name);

    let sel_matrics = metrics_arr
      .filter((d) => d?.toggle === true)
      .map((item) => item?.backend_matrice_name);

    let temp_obj = {
      filter: {
        current_data_range: {
          start_date: `${InputRange?.rangeOne?.startDate?.getFullYear()}-${String(
            InputRange?.rangeOne?.startDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeOne?.startDate?.getDate()
          ).padStart(2, "0")}`,

          end_date: `${InputRange?.rangeOne?.endDate?.getFullYear()}-${String(
            InputRange?.rangeOne?.endDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeOne?.endDate?.getDate()
          ).padStart(2, "0")}`,
        },
        previous_data_range: {
          start_date: `${InputRange?.rangeTwo?.startDate?.getFullYear()}-${String(
            InputRange?.rangeTwo?.startDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeTwo?.startDate?.getDate()
          ).padStart(2, "0")}`,

          end_date: `${InputRange?.rangeTwo?.endDate?.getFullYear()}-${String(
            InputRange?.rangeTwo?.endDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeTwo?.endDate?.getDate()
          ).padStart(2, "0")}`,
        },
        product_detail_filter: Object.fromEntries(
          Object.entries(sel_categories).filter(
            ([_, value]) => value.length > 0
          )
        ),
      },
      conditions: conditionsArr.map((singleCondition) => ({
        metric: singleCondition?.metric,
        parameter: singleCondition?.parameter,
        operator: singleCondition?.Operation.toUpperCase(),
        initial_value: Number(singleCondition?.initial_value),
        dependent_value: Number(singleCondition?.dependent_value),
      })),
      sort: {},
      product_detail_column: sel_product_details,
      metrics_column: sel_matrics,
    };

    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/placementTotal/getPlacementComparasionOfTwoRange?brand_id=${brand_id}&page=${pagination?.page}&limit=${pagination?.limit}`;
      const result = await axios.post(api, temp_obj, { headers });
      const { results, total } = result?.data?.data;
      if (results?.length === 0) {

      } else if (results.length > 0) {

        setTotal_data(convertTotalData(results[0], sel_matrics));
        // setDataFetchingState("SUCCESS");
      }
      
    } catch (error) {
      appError(error);
    } finally {
      setLoading(false);
    }
  };

  const debouncedTotalData = useMemo(
    () => debounce(fetchTotalData, 1000),
    [fetchTotalData]
  );

  useEffect(() => {
    if (
      brand_id &&
      productDetails?.length > 0 &&
      matricesData.length > 0
    ) {
      debouncedFetchData(productDetails, matricesData, hierarchy, matrices_hierarchy);
      debouncedTotalData(productDetails, matricesData);
    }
    return () => {
      debouncedFetchData.cancel();
      debouncedTotalData.cancel();
    };
  }, [
    InputRange,
    conditionsArr,
    sort,
    // productDetails,
    // matricesData,
    sel_categories,
    pagination
  ]);

  useEffect(()=>{
    if(productDetails?.length > 0 && matricesData?.length > 0){
      debouncedFetchData(productDetails, matricesData, hierarchy, matrices_hierarchy);
      debouncedTotalData(productDetails, matricesData);
    }
    return () => {
      debouncedFetchData.cancel();
      debouncedTotalData.cancel();
    };
  },[productDetails?.length, matricesData?.length]);

  // For Storing Data after changing SearchObj frontend and backend value
  const [searchDataArr, setSearchDataArr] = useState<SearchDataArrProps[]>([]);
  const [dropDownRawData, setDropDownRawData] = useState<any[]>([]);
  const [dropDownformatedData, setDropDownformatedData] = useState<All_CategoriesProps>({} as All_CategoriesProps); 

  useEffect(() => {
    if (brand_id) {
      if(searchobj?.backend_value_type !== "placementclassification"){
        setSearchDataArr(dropDownformatedData[searchobj?.backend_value_type]);
      }
      else {
        setSearchDataArr([
          {value: "Homepage on-Amazon"},
          {value : "Detail Page on-Amazon"},
          {value : "Other on-Amazon"},
          {value : "Top of Search on-Amazon"}
        ]);
      }
    }
  }, [searchobj?.backend_value_type]);

  const [dateToggle, setDateToggle] = useState<boolean>(false);

  const apply = (date: IpDate) => {
    setInputRange((prev) => ({
      ...prev,
      rangeOne: date?.rangeOne,
    }));
    setInputRange((prev) => ({
      ...prev,
      rangeTwo: date?.rangeTwo,
    }));
  };

  const [sortByToggle, setSortByToggle] = useState<boolean>(false);
  const [sortValues, setSortValues] = useState<string[]>([
    "current",
    "previous",
    "difference",
    "difference_percentage",
  ]);

  const [filterLists, setFilterLists] = useState<FilterButtonProps[]>([
    { id: "Select All", label: "Select All" },
    { id: "Sponsored Product", label: "Sponsored Product" },
    { id: "Sponsored Brands", label: "Sponsored Brand" },
    { id: "Sponsored Display", label: "Sponsored Display" },
  ]);
  const [selectedFilterLists, setSelectedFilterLists] = useState<Set<string>>(
    new Set([])
  );

  const onFilterListChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    let set = new Set(selectedFilterLists);
    if (e.target.checked) {
      if (id === "Select All") {
        filterLists.forEach((m) => set.add(m.id));
      } else if (id !== "Select All") {
        set.add(id);
        if (set.size === filterLists.length - 1) {
          set.add("Select All");
        }
      }
    } else {
      if (id === "Select All" && set.size === filterLists.length) {
        set.clear();
      } else if (id !== "Select All") {
        if (set.has("Select All")) {
          set.delete("Select All");
        }
        set.delete(id);
      }
    }
    setSel_Categories((prev) => ({
      ...prev,
      ad_type: [...set].filter((item) => item !== "Select All"),
    }));
    setSelectedFilterLists(set);
  };

  const [searchobjToggle, setSearchobjToggle] = useState<boolean>(false);
  const [searchobjtypeArr, setSearchobjTypeArr] = useState<SearchObjArr[]>([]);
  const [drawerToggle, setDrawerToggle] = useState<boolean>(false);
  const [drawerSubOption, setDrawerSubOption] = useState<string>("");
  const [conditionToggle, setConditionToggle] = useState<boolean>(false);

  const [matricsArr, setMatricsArr] = useState<MatricsProps[]>([
    {
      id: 1,
      matrice_name: "Impressions",
      backend_matrice_name: "impressions",
    },
    {
      id: 2,
      matrice_name: "Clicks",
      backend_matrice_name: "clicks",
    },
    {
      id: 3,
      matrice_name: "Spend",
      backend_matrice_name: "spend",
    },
    {
      id: 4,
      matrice_name: "Ad Sales",
      backend_matrice_name: "sales",
    },
    {
      id: 5,
      matrice_name: "Ad Orders",
      backend_matrice_name: "orders",
    },
    {
      id: 6,
      matrice_name: "Ad Units",
      backend_matrice_name: "units",
    },
    {
      id: 7,
      matrice_name: "ACOS",
      backend_matrice_name: "acos",
    },
    {
      id: 8,
      matrice_name: "ROAS",
      backend_matrice_name: "roas",
    },
    {
      id: 9,
      matrice_name: "CTR",
      backend_matrice_name: "ctr",
    },
    {
      id: 10,
      matrice_name: "CVR",
      backend_matrice_name: "cvr",
    },
    {
      id: 11,
      matrice_name: "CPC",
      backend_matrice_name: "cpc",
    },
    {
      id: 12,
      matrice_name: "AOV",
      backend_matrice_name: "aov",
    },
  ]);

  const [parameterArr, setParamterArr] = useState<ParametersProps[]>([
    {
      id: 1,
      parameter: "current",
    },
    {
      id: 2,
      parameter: "previous",
    },
    {
      id: 3,
      parameter: "difference",
    },
    {
      id: 4,
      parameter: "difference_percentage",
    },
  ]);

  const [operationsArr, setOperationsArr] = useState<OperationProps[]>([
    {
      id: 1,
      operation: "<",
    },
    {
      id: 2,
      operation: "=",
    },
    {
      id: 3,
      operation: ">",
    },
    {
      id: 4,
      operation: "Between",
    },
  ]);

  const [localconditions, setLocalConditions] = useState<Condition[]>([]); // Array for All Conditons Box
  const [local_Cond_name, setlocal_Cond_name] = useState<string>("");
  const [newconditionsArr, setNewConditionsArr] = useState<NewConditionProps[]>(
    local_Cond_name
      ? []
      : [
          {
            metric: "",
            parameter: "",
            Operation: "",
            initial_value: "",
            dependent_value: "",
          },
        ]
  );
  const [newcondition, setNewCondition] = useState<Condition>({
    metric: "",
    parameter: "",
    Operation: "",
    initial_value: "",
    dependent_value: "",
  });

  const [saveConditionToggle, setSaveConditionToggle] =
    useState<boolean>(false);
  const [listarr, setListArr] = useState<ListProps[]>([]);
  const [temp_list_name, setTemp_List_name] = useState<string>("");
  const [temp_list_name_error, setTemp_list_name_error] =
    useState<boolean>(false);
  const [localCondToggle, setLocalCondToggle] = useState<boolean>(false);
  const [local_Cond_id, setlocal_Cond_id] = useState<string>("");
  const [confirmConditionToggle, setConfirmConditionToggle] =
    useState<boolean>(false);
  const [conditonsSave, setConditionsSave] = useState<boolean>(false);
  const [isDbDataChanges, setIsDbDataChanges] = useState<boolean>(false);

  const createConditionLists = async () => {
    let temp_arr2 = [
      ...localconditions,
      ...newconditionsArr.filter(
        (cond) =>
          cond?.metric !== "" &&
          cond?.parameter !== "" &&
          cond?.Operation !== "" &&
          cond?.initial_value !== ""
      ),
    ];
    const cleaned_arr = temp_arr2.map((obj) =>
      Object.fromEntries(
        Object.entries(obj).filter(([key]) => !key.endsWith("_error"))
      )
    );
    try {
      setConditionsSave(true);
      const temp_condition_obj = {
        dashboard: "ADS_PLACEMENT_ANALYSIS_COMPARISON",
        condition_name: temp_list_name,
        condition_array: cleaned_arr,
      };
      const token = localStorage.getItem("token");
      const res = await axios.post(
        `${BASE_URL}settings/dashboardSettings/conditions?brand_id=${brand_id}&platform_id=${platform_id}`,
        temp_condition_obj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(res?.data?.data?.message);
      fetchConditionsData();
      setSaveConditionToggle(false);
      setNewConditionsArr([
        {
          metric: "",
          parameter: "",
          Operation: "",
          initial_value: "",
          dependent_value: "",
        },
      ]);
      setLocalConditions([]);
      setTemp_List_name("");
    } catch (error) {
      appError(error);
    } finally {
      setConditionsSave(false);
    }
  };

  let menuRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
  let menuButtonRef = useRef<HTMLButtonElement | null>(null); // Menu button reference

  let FilterRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
  let FilterButtonRef = useRef<HTMLImageElement | null>(null); // Menu button reference

  let SavedConditionsRef: MutableRefObject<HTMLDivElement | null> =
    useRef(null);
  let SavedConditionsBtnRef = useRef<HTMLImageElement | null>(null); // Menu button reference

  let exportRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
  let exportButtonRef = useRef<HTMLButtonElement | null>(null); // Menu button reference

  let dateRangeCmpRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
  let dateRangeCmpButtonRef = useRef<HTMLImageElement | null>(null); // Menu button reference
  
  const handleClickOutside = (event: MouseEvent) => {
    // Check if the click is outside the dropdown (menuRef)
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target as Node) &&
      menuButtonRef.current &&
      !menuButtonRef.current.contains(event.target as Node)
    ) {
      setSortByToggle(false); // Close the dropdown if clicked outside
    }
  };

  const FilterhandleClickOutside = (event: MouseEvent) => {
    // Check if the click is outside the dropdown (menuRef)
    if (
      FilterRef.current &&
      !FilterRef.current.contains(event.target as Node) &&
      FilterButtonRef.current &&
      !FilterButtonRef.current.contains(event.target as Node)
    ) {
      setSearchobjToggle(false); // Close the dropdown if clicked outside
    }
  };

  const SavedConditionshandleClickOutside = (event: MouseEvent) => {
    // Check if the click is outside the dropdown (menuRef)
    if (
      SavedConditionsRef.current &&
      !SavedConditionsRef.current.contains(event.target as Node) &&
      SavedConditionsBtnRef.current &&
      !SavedConditionsBtnRef.current.contains(event.target as Node)
    ) {
      setLocalCondToggle(false); // Close the dropdown if clicked outside
    }
  };

  const exporthandleClickOutside = (event: MouseEvent) => {
    // Check if the click is outside the dropdown (menuRef)
    if (
      exportRef.current &&
      !exportRef.current.contains(event.target as Node) &&
      exportButtonRef.current &&
      !exportButtonRef.current.contains(event.target as Node)
    ) {
      setExportToggle(false); // Close the dropdown if clicked outside
    }
  };

  const dateRangehandleClickOutside = (event: MouseEvent) => {
    // Check if the click is outside the dropdown (menuRef)
    if (
      dateRangeCmpRef.current &&
      !dateRangeCmpRef.current.contains(event.target as Node) &&
      dateRangeCmpButtonRef.current &&
      !dateRangeCmpButtonRef.current.contains(event.target as Node)
    ) {
      setDateToggle(false); // Close the dropdown if clicked outside
    }
  };

  // Add event listener to detect clicks outside
  useEffect(() => {
    // Attach the click event listener to the document
    document.addEventListener("click", handleClickOutside);
    document.addEventListener("click", FilterhandleClickOutside);
    document.addEventListener("click", SavedConditionshandleClickOutside);
    document.addEventListener("click", exporthandleClickOutside);
    document.addEventListener("click", dateRangehandleClickOutside);
    // Cleanup the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("click", FilterhandleClickOutside);
      document.removeEventListener("click", SavedConditionshandleClickOutside);
      document.removeEventListener("click", exporthandleClickOutside);
      document.removeEventListener("click", dateRangehandleClickOutside);
    };
  }, []);

  const ClearAll = () => {
    setLocalConditions([]);
    setlocal_Cond_name("");
    setNewConditionsArr([
      {
        metric: "",
        parameter: "",
        Operation: "",
        initial_value: "",
        dependent_value: "",
      },
    ]);
  };

  // PUT API for All 3 Column
  const updateColumns = async (
    ipNewProductDetailsArr: ProductDetailsProps[],
    column_name: string,
    ipNewParametersArr: Parameter[],
    ipNewMatricesArr: Matrice[],
    resetVar: boolean
  ) => {
    try {
      const token = localStorage.getItem("token");
      interface TempObj {
        dashboard: string;
        column_type: string;
        column_array?: any[]; // Optional property, replace `any[]` with a specific type if known
      }
      let temp_obj: TempObj = {
        dashboard: "ADS_PLACEMENT_ANALYSIS",
        column_type: column_name,
      };
      if (column_name === "PRODUCT_DETAILS") {
        temp_obj.column_array = ipNewProductDetailsArr;
      } else if (column_name === "PARAMETER") {
        temp_obj.column_array = ipNewParametersArr;
      } else if (column_name === "METRICE") {
        temp_obj.column_array = ipNewMatricesArr;
      }
      const res = await axios.put(
        `${BASE_URL}settings/columnSettings?brand_id=${brand_id}&platform_id=${platform_id}`,
        temp_obj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      appError(error);
    }
  };

  // For Product Detail
  const ProductDetailSwitchChangeHandler = (detail_id: Number) => {
      const Exist = productDetailsDrawer.find(
        (d: ProductDetailsProps) => d?.id === detail_id
      )?.toggle;
      let newProductDetailsArr = [] as ProductDetailsProps[];
      if (Exist) {
        if (productDetailsDrawer.filter((item) => item.toggle).length === 1) {
                toast.error("Minimum 1 Product Detail to be present");
                return;
              } else if (productDetailsDrawer.filter((item) => item.toggle).length > 1) {
                newProductDetailsArr = productDetailsDrawer.map((d) =>
                  d.id === detail_id ? { ...d, toggle: false } : d
                );
              }
      } else {
        newProductDetailsArr = productDetailsDrawer.map((d) =>
          d.id === detail_id ? { ...d, toggle: true } : d
        );
      }
      setProductDetailsDrawer(newProductDetailsArr);
    };

  // For Parameter
  const ParameterSwitchChangeHandler = (parameter_id: Number) => {
    const Exist = parametersDataDrawer.find(
      (d: Parameter) => d?.id === parameter_id
    )?.toggle;
    let newParameterArr = [] as Parameter[];
    if (Exist) {
      if (parametersDataDrawer.filter((item) => item.toggle).length === 1) {
        toast.error("Minimum 1 Parameter to be present");
        return;
      } else if (parametersDataDrawer.filter((item) => item.toggle).length > 1) {
        newParameterArr = parametersDataDrawer.map((d) =>
          d.id === parameter_id ? { ...d, toggle: false } : d
        );
      }
    } else {
      newParameterArr = parametersDataDrawer.map((d) =>
        d.id === parameter_id ? { ...d, toggle: true } : d
      );
    }
    setParametersDataDrawer(newParameterArr);
    // updateColumns([], "PARAMETER", newParameterArr, [], true);
  };

  // For Metricess
  const MatriceSwitchChangeHandler = (matrice_id: Number) => {
    const Exist = matricesDataDrawer.find(
      (d: Matrice) => d?.id === matrice_id
    )?.toggle;
    let newMatricesArr = [] as Matrice[];
    if (Exist) {
      if (matricesDataDrawer.filter((item) => item.toggle).length === 1) {
        toast.error("Minimum 1 Matrice to be present");
        return;
      } else if (matricesDataDrawer.filter((item) => item.toggle).length > 1) {
        newMatricesArr = matricesDataDrawer.map((d) =>
          d.id === matrice_id ? { ...d, toggle: false } : d
        );
      }
    } else {
      newMatricesArr = matricesDataDrawer.map((d) =>
        d.id === matrice_id ? { ...d, toggle: true } : d
      );
    }
    setMatricesDataDrawer(newMatricesArr);
    // updateColumns([], "METRICE", [], newMatricesArr, true);
  };
  
  // Drag & Drop Functionality
  // For Product Detail
  const [draggedProductDetail, setDraggedProductDetail] =
    useState<ProductDetailsProps | null>(null);

  const productDetailsDragStarthandle = (item: ProductDetailsProps) => {
    setDraggedProductDetail(item);
  };

  const productDetailsDragOverhandle = (
    event: React.DragEvent<HTMLDivElement>
  ) => {
    event.preventDefault();
  };

  const productDetailshandleDrop = (targetItem: ProductDetailsProps) => {
    if (!draggedProductDetail || draggedProductDetail.id === targetItem.id) return;
  
    const draggedIndex = productDetailsDrawer.findIndex(
      (item) => item?.id === draggedProductDetail.id
    );
    const targetIndex = productDetailsDrawer.findIndex(
      (item) => item?.id === targetItem.id
    );
  
    if (draggedIndex === -1 || targetIndex === -1) return;
  
    // Clone the array to avoid mutating state directly
    const updatedMatricesData = [...productDetailsDrawer];
  
    // Remove the dragged item
    const [draggedMatrice] = updatedMatricesData.splice(draggedIndex, 1);
  
    // Insert it at the target index
    updatedMatricesData.splice(targetIndex, 0, draggedMatrice);
  
    // Reassign position field based on new order
    const reorderedMatricesData = updatedMatricesData.map((item, index) => ({
      ...item,
      position: index,
    }));
      setProductDetailsDrawer(reorderedMatricesData);
  };

  // For Parameter
  const [draggedParameter, setDraggedParameter] = useState<Parameter | null>(
    null
  );

  const parameterDragStarthandle = (item: Parameter) => {
    setDraggedParameter(item);
  };

  const parameterDragOverhandle = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const parameterhandleDrop = (targetItem: Parameter) => {
    if (!draggedParameter || draggedParameter.id === targetItem.id) return;
  
    const draggedIndex = parametersDataDrawer.findIndex(
      (item) => item?.id === draggedParameter.id
    );
    const targetIndex = parametersDataDrawer.findIndex(
      (item) => item?.id === targetItem.id
    );
  
    if (draggedIndex === -1 || targetIndex === -1) return;
  
    // Clone the array to avoid mutating state directly
    const updatedMatricesData = [...parametersDataDrawer];
  
    // Remove the dragged item
    const [draggedMatrice] = updatedMatricesData.splice(draggedIndex, 1);
  
    // Insert it at the target index
    updatedMatricesData.splice(targetIndex, 0, draggedMatrice);
  
    // Reassign position field based on new order
    const reorderedMatricesData = updatedMatricesData.map((item, index) => ({
      ...item,
      position: index,
    }));
      setParametersDataDrawer(reorderedMatricesData);
  };

  // For Metrice
  const [draggedMetrice, setDraggedMetrice] = useState<Matrice | null>(null);

  const metriceDragStarthandle = (item: Matrice) => {
    setDraggedMetrice(item);
  };

  const metriceDragOverhandle = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const metricehandleDrop = (targetItem: Matrice) => {
    if (!draggedMetrice || draggedMetrice.id === targetItem.id) return;
  
    const draggedIndex = matricesDataDrawer.findIndex(
      (item) => item?.id === draggedMetrice.id
    );
    const targetIndex = matricesDataDrawer.findIndex(
      (item) => item?.id === targetItem.id
    );
  
    if (draggedIndex === -1 || targetIndex === -1) return;
  
    // Clone the array to avoid mutating state directly
    const updatedMatricesData = [...matricesDataDrawer];
  
    // Remove the dragged item
    const [draggedMatrice] = updatedMatricesData.splice(draggedIndex, 1);
  
    // Insert it at the target index
    updatedMatricesData.splice(targetIndex, 0, draggedMatrice);
  
    // Reassign position field based on new order
    const reorderedMatricesData = updatedMatricesData.map((item, index) => ({
      ...item,
      position: index,
    }));
      setMatricesDataDrawer(reorderedMatricesData);
  };

  const [searchFocus, setSearchFocus] = useState<boolean>(false);
  const [searchFileArray, setSearchFileArray] = useState<SearchDataArrProps[]>(
    []
  );

  const handleSearch = (event: any) => {
    const searchValue = event.target.value;
    setSearchObj((prev) => ({
      ...prev,
      value: searchValue,
    }));

    // Filter the data based on input
    const filteredResults = searchDataArr
      .filter((item) =>
        item.value?.toString().toLowerCase().includes(searchValue.toLowerCase())
      )
      .slice(0, 10);
    if (searchValue === "") {
      setSel_Categories({
        ad_type: [],
        campaign_name: [],
        placementclassification: [],
      });
      setSel_CategoriesDrawer({
        ad_type: [],
        campaign_name: [],
        placementclassification: [],
      });
    }
    setSearchFileArray(filteredResults);
  };

  const onSearchvalueInputChange = (e: any) => {
    if (e.target.value?.trimStart()) {
      setSearchFocus(true);
      setSearchobjToggle(false);
    } else {
      setSearchFocus(false);
    }
    handleSearch(e);
  };

  const [resetToggle, setResetToggle] = useState<boolean>(false);

  const onResetColumnsHandler = () => {
    setParametersDataDrawer((prev) => {
      const sortedMatrices = [...prev].sort((a, b) => a.id - b.id);
      
      // Update the position field in numerical order
      const updatedMatrices = sortedMatrices.map((item, index) => ({
        ...item,
        position: index, // Assign position based on the index in the sorted array
      }));
      
      return updatedMatrices;
    });

    setMatricesDataDrawer((prev) => {
      const sortedMatrices = [...prev].sort((a, b) => a.id - b.id);
      
      // Update the position field in numerical order
      const updatedMatrices = sortedMatrices.map((item, index) => ({
        ...item,
        position: index, // Assign position based on the index in the sorted array
      }));
      
      return updatedMatrices;
    });

    setProductDetailsDrawer((prev) => {
      const sortedMatrices = [...prev].sort((a, b) => a.id - b.id);
      
      // Update the position field in numerical order
      const updatedMatrices = sortedMatrices.map((item, index) => ({
        ...item,
        position: index, // Assign position based on the index in the sorted array
      }));
      
      return updatedMatrices;
    });
  };

  const [isProductDetailsFetched, setIsProductDetailsFetched] = useState(false);

  // GET API For All 3 Columns
  const fetchColumnData = async (column_name: string) => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}settings/columnSettings?brand_id=${brand_id}&platform_id=${platform_id}&dashboard=ADS_PLACEMENT_ANALYSIS&column_type=${column_name}`;
      const result = await axios.get(api, { headers });
      const { column_array } = result.data.data;
      if (column_name === "PARAMETER") {
        if (column_array.length > 0) {
          setParametersData(column_array);
          setParametersDataDrawer(column_array);
          let positionchangedfilter =  column_array?.filter((item: Parameter, index: number) => item.id !== (index + 1));
          if(positionchangedfilter?.length > 0){
            setResetToggle(true);
          }
          setParameters_hierarchy(
            column_array.map(
              (column: Parameter) => column.backend_parameter_name
            )
          );
          setSel_Parameters(
            column_array
              .filter((m: Parameter) => m?.toggle === true)
              .map((item: Parameter) => item?.backend_parameter_name)
          );
        } else {
          let new_parameters_arr =[
            {
              id: 1,
              parameter_name: "Current Period",
              backend_parameter_name: "current",
              toggle: true,
              position: 0,
            },
            {
              id: 2,
              parameter_name: "Comparison Period",
              backend_parameter_name: "previous",
              toggle: false,
              position: 1,
            },
            {
              id: 3,
              parameter_name: "Difference",
              backend_parameter_name: "difference",
              toggle: false,
              position: 2,
            },
            {
              id: 4,
              parameter_name: "Difference %",
              backend_parameter_name: "difference_percentage",
              toggle: false,
              position: 3,
            },
          ];
          setParametersData([...new_parameters_arr]);
          setParametersDataDrawer([...new_parameters_arr]);

          setParameters_hierarchy([
            "current",
            "previous",
            "difference",
            "difference_percentage",
          ]);
          setSel_Parameters([
            "current",
            // "previous",
            // "difference",
            // "difference_percentage",
          ]);
        }
      } else if (column_name === "METRICE") {
        if (column_array.length > 0) {
          setMatricesData(column_array);
          setMatricesDataDrawer(column_array);
          let positionchangedfilter =  column_array?.filter((item: Parameter, index: number) => item.id !== (index + 1));
          if(positionchangedfilter?.length > 0){
            setResetToggle(true);
          }
          setMatrices_hierarchy(
            column_array.map((column: Matrice) => column.backend_matrice_name)
          );
        } else {
          let new_matrics_arr = [
            {
              id: 1,
              matrice_name: "Impressions",
              backend_matrice_name: "impressions",
              toggle: false,
              position: 0,
            },
            {
              id: 2,
              matrice_name: "Clicks",
              backend_matrice_name: "clicks",
              toggle: false,
              position: 1,
            },
            {
              id: 3,
              matrice_name: "Spend",
              backend_matrice_name: "spend",
              toggle: true,
              position: 2,
            },
            {
              id: 4,
              matrice_name: "Ad Sales",
              backend_matrice_name: "sales",
              toggle: true,
              position: 3,
            },
            {
              id: 5,
              matrice_name: "Ad Orders",
              backend_matrice_name: "orders",
              toggle: true,
              position: 4,
            },
            {
              id: 6,
              matrice_name: "Ad Units",
              backend_matrice_name: "units",
              toggle: false,
              position: 5,
            },
            {
              id: 7,
              matrice_name: "ACOS",
              backend_matrice_name: "acos",
              toggle: true,
              position: 6,
            },
            {
              id: 8,
              matrice_name: "ROAS",
              backend_matrice_name: "roas",
              toggle: false,
              position: 7,
            },
            {
              id: 9,
              matrice_name: "CTR",
              backend_matrice_name: "ctr",
              toggle: false,
              position: 8,
            },
            {
              id: 10,
              matrice_name: "CVR",
              backend_matrice_name: "cvr",
              toggle: true,
              position: 9,
            },
            {
              id: 11,
              matrice_name: "CPC",
              backend_matrice_name: "cpc",
              toggle: true,
              position: 10,
            },
            {
              id: 12,
              matrice_name: "AOV",
              backend_matrice_name: "aov",
              toggle: false,
              position: 11,
            },
          ];
          setMatricesData(new_matrics_arr);
          setMatricesDataDrawer(new_matrics_arr);
          setMatrices_hierarchy([
            "impressions",
            "clicks",
            "spend",
            "sales",
            "orders",
            "units",
            "acos",
            // "tacos",
            "roas",
            // "troas",
            "ctr",
            "cvr",
            "cpc",
            "aov",
            // "cac",
            // "gross_glanceviews",
          ]);
        }
      } else if (column_name === "PRODUCT_DETAILS") {
        if (column_array.length > 0) {
          setProductDetails(column_array);
          setProductDetailsDrawer(column_array);
          let positionchangedfilter =  column_array?.filter((item: Parameter, index: number) => item.id !== (index + 1));
          if(positionchangedfilter?.length > 0){
            setResetToggle(true);
          }
          setHierarchy(
            column_array.map(
              (column: ProductDetailsProps) => column.backend_name
            )
          );
          setSel_ProductDetails(
            column_array.filter((d: ProductDetailsProps) => d?.toggle === true)
          );
          // setResetToggle(true);
        } else {
          let new_product_details = [
            {
              id: 1,
              detail_name: "Ad Type",
              backend_name: "ad_type",
              toggle: true,
              position: 0,
            },
            {
              id: 2,
              detail_name: "Campaign Name",
              backend_name: "campaign_name",
              toggle: true,
              position: 1,
            },
            {
              id: 3,
              detail_name: "Placement",
              backend_name: "placementclassification",
              toggle: true,
              position: 2,
            }];
          setProductDetails(new_product_details);
          setProductDetailsDrawer(new_product_details);

          setHierarchy(() => {
            const baseFields = [
              "ad_type",
              "campaign_name",
              "placementclassification",
            ];

            return baseFields;
          });

          setSel_ProductDetails([
            {
              id: 1,
              detail_name: "Ad Type",
              backend_name: "ad_type",
              toggle: true,
              position: 0,
            },
            {
              id: 2,
              detail_name: "Campaign Name",
              backend_name: "campaign_name",
              toggle: true,
              position: 1,
            },
            {
              id: 3,
              detail_name: "Placement",
              backend_name: "placementclassification",
              toggle: true,
              position: 2,
            }]);
        }
        setIsProductDetailsFetched(true); // Set flag when product details are updated
      }
    } catch (error) {
      appError(error);
    } finally {
      setLoading(false);
    }
  };

  // GET API for All Saved Conditions from Backend
  const fetchConditionsData = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}settings/dashboardSettings/conditions?brand_id=${brand_id}&platform_id=${platform_id}&dashboard=ADS_PLACEMENT_ANALYSIS_COMPARISON`;
      const result = await axios.get(api, { headers });
      const { data } = result?.data;
      setListArr(data);
    } catch (error) {
      appError(error);
    } finally {
      setLoading(false);
    }
  };

  const getBrandDetails = () => {
    const storedBrandRange = localStorage.getItem("BrandRange");
    const storedBrand = localStorage.getItem("brand");
    if (storedBrandRange && storedBrand) {
      try {
        const parsedRange = JSON.parse(storedBrandRange);
        const parsedBrand = JSON.parse(storedBrand);
        setHierarchy_levels(Number(parsedBrand?.category_hierarchy_level));
        setRange({
          min_date: new Date(parsedRange?.min_date.split("T")[0]),
          max_date: new Date(parsedRange?.max_date.split("T")[0]),
        });
        setInputRange(() => {
          let weekRange = getWeekRange(new Date());
          if (
            weekRange &&
            weekRange?.currentWeekStart >
              new Date(parsedRange?.max_date.split("T")[0])
          ) {
            weekRange = getWeekRange(
              new Date(parsedRange?.max_date.split("T")[0])
            );
          }
          return {
            rangeOne: {
              startDate: weekRange?.currentWeekStart || today,
              endDate: new Date(parsedRange?.max_date.split("T")[0]),
            },
            rangeTwo: {
              startDate: weekRange?.previousWeekStart || today,
              endDate: weekRange?.previousWeekEnd || today,
            },
          };
        });
      } catch (error) {
        appError("Error parsing BrandRange from localStorage:", error);
      }
    }
  };

  useEffect(() => {
    if (brand_id && platform_id) {
      getBrandDetails();
      fetchConditionsData();
    }
    if (brand_id && platform_id && hierarchy_levels > 0) {
      fetchColumnData("PRODUCT_DETAILS");
      fetchColumnData("PARAMETER");
      fetchColumnData("METRICE");

      setInitial_Header_Data(() => {
        let initialdata = [
          { title_name: "Ad Type", type: "ad_type", width: 100 },
          { title_name: "Campaign Name", type: "campaign_name", width: 125 },
          { title_name: "Placement", type: "placementclassification", width: 125 },
        ];

        return initialdata;
      });

      setSearchobjTypeArr(() => {
        let initialdata = [
          {
            detail_name: "Ad Type",
            backend_name: "ad_type",
          },
          {
            detail_name: "Campaign Name",
            backend_name: "campaign_name",
          },
          {
            detail_name: "Placement",
            backend_name: "placementclassification",
          }];
         
        return initialdata;
      });
    }
  }, [brand_id, platform_id, hierarchy_levels]);

  // Create a new Condition
  const [createNewCond, setCreateNewCond] = useState<boolean>(false);

  const onSearchValueChange = (Ipvalue: string) => {
    setSearchObj((prev) => ({
      ...prev,
      value: Ipvalue,
    }));

    const arr_name =
      searchobj?.backend_value_type?.toLowerCase() as keyof All_Sel_CategoriesProps;

    setSel_Categories((prevState) => ({
      ...prevState,
      [arr_name]: [Ipvalue], // Ensure array exists
    }));

    setSearchFocus(false);
  };

  type ProductDetails = { [key: string]: string | null };

  type UpdateCategoriesFunction = (
    results: ProductDetails[],
    sel_productdetails: string[]
  ) => void;

  // const [dropDownRawData, setDropDownRawData] = useState<any[]>([]);
  
  // const updateDropDownCategories: UpdateCategoriesFunction = (
  //   results,
  //   sel_productdetails
  // ) => {
  //   setCategories((prevCategories: All_CategoriesProps) => {
  //     const newCategories: All_CategoriesProps = { ...prevCategories };

  //     results.forEach((item) => {
  //       sel_productdetails.forEach((key) => {
  //         if (item[key] && key in newCategories) {
  //           const valueExists = newCategories[key].some(
  //             (entry: SearchDataArrProps) => entry.value === item[key]
  //           );
  //           if (!valueExists) {
  //             newCategories[key] = [
  //               ...newCategories[key],
  //               { value: item[key] as string },
  //             ];
  //           }
  //         }
  //       });
  //     });

  //     return newCategories;
  //   });
  // };

  const fetchDropDownData = async () => {
    let sel_product_details = productDetails?.map((item) => item?.backend_name);

    let temp_obj = {
      filter: {
        current_data_range: {
          start_date: `${InputRange?.rangeOne?.startDate?.getFullYear()}-${String(
            InputRange?.rangeOne?.startDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeOne?.startDate?.getDate()
          ).padStart(2, "0")}`,

          end_date: `${InputRange?.rangeOne?.endDate?.getFullYear()}-${String(
            InputRange?.rangeOne?.endDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeOne?.endDate?.getDate()
          ).padStart(2, "0")}`,
        },
        previous_data_range: {
          start_date: `${InputRange?.rangeTwo?.startDate?.getFullYear()}-${String(
            InputRange?.rangeTwo?.startDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeTwo?.startDate?.getDate()
          ).padStart(2, "0")}`,

          end_date: `${InputRange?.rangeTwo?.endDate?.getFullYear()}-${String(
            InputRange?.rangeTwo?.endDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeTwo?.endDate?.getDate()
          ).padStart(2, "0")}`,
        },
        product_detail_filter: {},
      },
      conditions: conditionsArr.map((singleCondition) => ({
        metric: singleCondition?.metric,
        parameter: singleCondition?.parameter,
        operator: singleCondition?.Operation.toUpperCase(),
        initial_value: Number(singleCondition?.initial_value),
        dependent_value: Number(singleCondition?.dependent_value),
      })),
      product_detail_column: [
        "ad_type",
        "campaign_name",
        "placementclassification"
      ],
    };

    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/placementDropDown/getPlacementComparasionOfTwoRange?brand_id=${brand_id}`;
      const result = await axios.post(api, temp_obj, { headers });
      const { row, results } = result?.data?.data;
      if (row?.length > 0) {
        setDropDownRawData(row); 
        setDropDownformatedData(results);
        setCategories(results);
      }
    } catch (error) {
      appError(error);
    } finally {
      setLoading(false);
    }
  };

  // function to Change dropdwon data On Switching Off for 1st column
  const onSelCategorySwitchBtn = (
    column_name: string,
    sel_arr: string[],
    sel_productcols: ProductDetailsProps[]
  ) => {
    let sel_product_details = productDetails?.map((item) => item?.backend_name);

    // If array of selected category is empty 
      if (sel_arr?.length === 0) {
        const checkIndex = sel_productDetails?.findIndex(
          (detail) => detail?.backend_name === column_name
        );

        // If Column is 1st from Selected Product Details column
        if(checkIndex === 0) {
          setCategories(dropDownformatedData);
        }

        // If Column is not 1st from Selected Product Details column
        else if(checkIndex > 0){
          const prevcategories = hierarchy.slice(
            0,
            hierarchy.indexOf(column_name)
          );

          // const validPrevCategories = prevcategories.filter(item => sel_categories[item] && sel_categories[item].length > 0);
          const validPrevCategories = prevcategories.filter(item => sel_categories[item] && sel_categories[item].length > 0);

          // if Previous categories whose selected values > 0 are present
          if (validPrevCategories.length > 0) {

            const filteredCategories = Object.keys(sel_categories).reduce<{ [key: string]: string[] }>((acc, category) => {
              if (prevcategories.includes(category) && sel_categories[category].length > 0) {
                acc[category] = sel_categories[category]; // Keep category if non-empty
              }
              return acc;
            }, {});
            const filteredDropdownData = dropDownRawData?.filter(item => {
                return Object.keys(filteredCategories).every(categoryKey => {
                  return filteredCategories[categoryKey].includes(item[categoryKey]);
                });
              })
              .map(item => {
                // Create a new object by removing fields from prevCategories
                let newItem = { ...item };
  
                // Remove the keys specified in prevCategories from each item
                prevcategories.forEach(categoryKey => {
                  delete newItem[categoryKey]; // Remove the category field from the result
                });
  
                return newItem; // Return the modified item
              });
              const filteredResults = hierarchy.slice(hierarchy.indexOf(column_name) + 1);

            setCategories((prev) => {
              const newCategories: All_CategoriesProps = { ...prev };
  
              filteredResults.forEach((key) => {
                if (key in newCategories) {
                  // Collect unique values for this key
                  const uniqueValues = Array.from(
                    new Set(
                      filteredDropdownData
                        ?.map((item) => item[key])
                        .filter(Boolean)
                    )
                  ).map((value) => ({ value: value as string }));
                  // Replace existing array with the new unique values
                  newCategories[key] = uniqueValues;
                }
              });
  
              return newCategories;
            });
          } 

          // if Previous categories whose selected values > 0 are not present
          else {
            setCategories(dropDownformatedData);
          }
  
        }
      // If array of selected category is not empty
      } else {
      const updatedArray = hierarchy.slice(hierarchy.indexOf(column_name) + 1);
      const filteredResults = updatedArray;
      const checkIndex = sel_productcols?.findIndex(
        (detail) => detail?.backend_name === column_name
      );
      // If Column is 1st from Selected Product Details column
      if (checkIndex === 0) {
        const filtered_dropdownRawData = dropDownRawData
          ?.filter((item) => sel_arr.includes(item[column_name] as string)) // Filter based on column_name & sel_arr
          .map(({ [column_name]: _, ...rest }) => rest);

        setCategories((prevCategories: All_CategoriesProps) => {
          const newCategories: All_CategoriesProps = { ...prevCategories };

          filteredResults.forEach((key) => {
            if (key in newCategories) {
              // Collect unique values for this key
              const uniqueValues = Array.from(
                new Set(
                  filtered_dropdownRawData
                    ?.map((item) => item[key])
                    .filter(Boolean)
                )
              ).map((value) => ({ value: value as string }));
              // Replace existing array with the new unique values
              newCategories[key] = uniqueValues;
            }
          });

          return newCategories;
        });
      } 

      // If Column is not 1st from Selected Product Details column
      else if (checkIndex > 0) {
        const previously_sel_cols = hierarchy.slice(
          0,
          hierarchy.indexOf(column_name)
        );

        const filtered_dropdownRawData = dropDownRawData.filter((item) => {
          // Check if the item matches the column_name filter
          const columnMatch = sel_arr.includes(item[column_name]);

          // Check if previously selected product details exist in sel_categories
          const prevSelectionsMatch = previously_sel_cols.every((prevKey) => {
            return (
              sel_categories[prevKey]?.length === 0 ||
              sel_categories[prevKey].includes(item[prevKey])
            );
          });

          return columnMatch && prevSelectionsMatch;
        });

        setCategories((prevCategories: All_CategoriesProps) => {
          const newCategories: All_CategoriesProps = { ...prevCategories };

          filteredResults.forEach((key) => {
            if (key in newCategories) {
              // Collect unique values for this key
              const uniqueValues = Array.from(
                new Set(
                  filtered_dropdownRawData
                    ?.map((item) => item[key])
                    .filter(Boolean)
                )
              ).map((value) => ({ value: value as string }));

              // Replace existing array with the new unique values
              newCategories[key] = uniqueValues;
            }
          });

          return newCategories;
        });
      }
    }
  };

  const onSelCategory = (column_name: string, sel_arr: string[]) => {
    setSel_CategoriesDrawer((prev) => ({
      ...prev,
      [column_name]: sel_arr
    }));
  }

  useEffect(() => {
    if (isProductDetailsFetched) {
      fetchDropDownData();
      setIsProductDetailsFetched(false); // Reset to prevent multiple calls
    }
  }, [isProductDetailsFetched]);

  useEffect(() => {
    if (brand_id && !isProductDetailsFetched) {
      fetchDropDownData();
    }
  }, [InputRange, conditionsArr, brand_id, isProductDetailsFetched]);

  const DropDownApplyBtn = (column_name: string) => {
    setSel_Categories((prev) =>( {
      ...prev,
      ...sel_categoriesdrawer
    }));

    const column_index = sel_productDetails?.findIndex((detail) => detail?.backend_name === column_name);
    let sel_product_details = productDetails?.map((item) => item?.backend_name);

    // If array of selected category is empty 
    if(sel_categoriesdrawer[column_name]?.length === 0){

      // If Column is 1st from Selected Product Details column
      if(column_index === 0){
        setCategories(dropDownformatedData);
        // updateDropDownCategories(dropDownRawData, sel_product_details);
      }

      // If Column is not 1st from Selected Product Details column
      else if(column_index > 0){
        const prevcategories = hierarchy.slice(
          0,
          hierarchy.indexOf(column_name)
        );
        // Filter out previous categories whose selected values > 0
        const validPrevCategories = prevcategories.filter(item => sel_categories[item] && sel_categories[item].length > 0);

        // if Previous categories whose selected values > 0 are present
        if(validPrevCategories?.length > 0){

          const filteredCategories = Object.keys(sel_categories).reduce<{ [key: string]: string[] }>((acc, category) => {
            if (prevcategories.includes(category) && sel_categories[category].length > 0) {
              acc[category] = sel_categories[category]; // Keep category if non-empty
            }
            return acc;
          }, {});

          const filteredDropdownData = dropDownRawData?.filter(item => {
            return Object.keys(filteredCategories).every(categoryKey => {
              return filteredCategories[categoryKey].includes(item[categoryKey]);
            });
          }).map(item => {
            // Create a new object by removing fields from prevCategories
            let newItem = { ...item };

            // Remove the keys specified in prevCategories from each item
            prevcategories.forEach(categoryKey => {
              delete newItem[categoryKey]; // Remove the category field from the result
            });

            return newItem; // Return the modified item
          });

          const filteredResults = hierarchy.slice(hierarchy.indexOf(column_name) + 1);
          
          setCategories((prev) => {
            const newCategories: All_CategoriesProps = { ...prev };

            filteredResults.forEach((key) => {
              if (key in newCategories) {
                // Collect unique values for this key
                const uniqueValues = Array.from(
                  new Set(
                    filteredDropdownData
                      ?.map((item) => item[key])
                      .filter(Boolean)
                  )
                ).map((value) => ({ value: value as string }));
                // Replace existing array with the new unique values
                newCategories[key] = uniqueValues;
              }
            });

            return newCategories;
          });
        }

        // if Previous categories whose selected values > 0 are not present
        else if(validPrevCategories?.length === 0){
          setCategories(dropDownformatedData);
        }
      }
    }

    // If array of selected category is not empty 
    else if(sel_categoriesdrawer[column_name]?.length > 0){
      const nextallcategories = hierarchy.slice(hierarchy.indexOf(column_name) + 1);
      
      // If Column is 1st from Selected Product Details column
      if(column_index === 0){
        const filteredCategories = Object.keys(sel_categories).reduce<{ [key: string]: string[] }>((acc, category) => {
          if (sel_categories[category].length > 0) {
            acc[category] = sel_categories[category]; // Keep category if non-empty
          }
          return acc;
        }, {});
        const temp_arr = [filteredCategories, {[column_name] : sel_categoriesdrawer[column_name]}];

        const filteredData = dropDownRawData?.filter((item) => {
          return temp_arr.every((filter) => {
            return Object.keys(filter).every((key) => {
              return filter[key].includes(item[key]);
            });
          });
        }).map((item) => {
          // Remove the fields that are present in temp_arr
          const updatedItem = { ...item };
          Object.keys(updatedItem).forEach((key) => {
            temp_arr.forEach((filter) => {
              if (filter[key] && filter[key].includes(updatedItem[key])) {
                delete updatedItem[key];
              }
            });
          });
          return updatedItem;
        });

        const resultGrouped = filteredData.reduce((acc, item) => {
          // Loop through each key of the item
          Object.keys(item).forEach(key => {
            // Initialize the key in accumulator if not present
            if (!acc[key]) {
              acc[key] = [];
            }
        
            // Only add the value if it's not already in the array (unique values)
            if (!acc[key].includes(item[key])) {
              acc[key].push(item[key]);
            }
          });
        
          return acc;
        }, {});

        const transformedCategories = Object.keys(resultGrouped).reduce((acc, key) => {
          // Wrap each value inside an object with 'value' key
          acc[key] = resultGrouped[key].map((item: string) => ({ value: item }));
          return acc;
        }, {} as { [key: string]: { value: string }[] }); 

        setCategories((prev) => {
          const newCategories: All_CategoriesProps = {...prev, ...transformedCategories};
          
          return newCategories;
        });
      }
      
      // If Column is not 1st from Selected Product Details column
      else if(column_index > 0){
        const previously_sel_cols = hierarchy.slice(
          0,
          hierarchy.indexOf(column_name)
        );

        const filtered_dropdownRawData = dropDownRawData.filter((item) => {
          // Check if the item matches the column_name filter
          const columnMatch = sel_categoriesdrawer[column_name]?.includes(item[column_name]);

          // Check if previously selected product details exist in sel_categories
          const prevSelectionsMatch = previously_sel_cols.every((prevKey) => {
            return (
              sel_categories[prevKey]?.length === 0 ||
              sel_categories[prevKey].includes(item[prevKey])
            );
          });

          return columnMatch && prevSelectionsMatch;
        });

        setCategories((prevCategories: All_CategoriesProps) => {
          const newCategories: All_CategoriesProps = { ...prevCategories };

          nextallcategories.forEach((key) => {
            if (key in newCategories) {
              // Collect unique values for this key
              const uniqueValues = Array.from(
                new Set(
                  filtered_dropdownRawData
                    ?.map((item) => item[key])
                    .filter(Boolean)
                )
              ).map((value) => ({ value: value as string }));

              // Replace existing array with the new unique values
              newCategories[key] = uniqueValues;
            }
          });

          return newCategories;
        });
      }
    }

  };

  const columnsApply = () => {
    if(productDetailsDrawer?.length > 0 && matricesDataDrawer?.length > 0 && parametersDataDrawer?.length > 0){

      let productspositionChanged =  productDetailsDrawer?.filter((item: ProductDetailsProps, index: number) => item.id !== (index + 1));
      let parameterspositionChanged =  parametersDataDrawer?.filter((item: Parameter, index: number) => item.id !== (index + 1));
      let matricespositionChanged =  matricesDataDrawer?.filter((item: Matrice, index: number) => item.id !== (index + 1));

      if(productspositionChanged?.length > 0 || parameterspositionChanged?.length > 0 || matricespositionChanged?.length > 0){
        setResetToggle(true);
      } else {
        setResetToggle(false);
      }

      setSel_Parameters(
        parametersDataDrawer
          .filter((m) => m?.toggle === true)
          .map((item) => item?.backend_parameter_name)
      );
      setDrawerToggle(false);

      setProductDetails([...productDetailsDrawer]);
      let new_product_details_hierarchy = productDetailsDrawer?.map(item => item?.backend_name);
      setHierarchy(new_product_details_hierarchy);
      setSel_ProductDetails(productDetailsDrawer?.filter((d) => d?.toggle === true));
      updateColumns(productDetailsDrawer, "PRODUCT_DETAILS", [], [], true);
      setHierarchy(productDetailsDrawer?.map((m) => m?.backend_name));

      setParametersData([...parametersDataDrawer]);
      setParameters_hierarchy(
          parametersDataDrawer?.map((m) => m?.backend_parameter_name)
        );
      updateColumns([], "PARAMETER", parametersDataDrawer, [], true);

      setMatrices_hierarchy(
        matricesDataDrawer?.map((m) => m?.backend_matrice_name)
      );
      setMatricesData([...matricesDataDrawer]);
      let new_metrics_hierarchy = matricesDataDrawer?.map(item => item?.backend_matrice_name);
      setMatrices_hierarchy(new_metrics_hierarchy);
      updateColumns([], "METRICE", [], matricesDataDrawer, true);

      const togglesChangedarr = productDetailsDrawer?.filter((item) => {
        const prevItem = productDetails?.find((prev) => prev.id === item.id);
        return prevItem && prevItem.toggle !== item.toggle;
      });
  
      togglesChangedarr?.map((item) => {
        if(!item?.toggle){
          if(sel_categories[item?.backend_name]?.length > 0){
            setSel_Categories(prev => ({
              ...prev,
              [item?.backend_name]: []
            }));
            setSel_CategoriesDrawer(prev => ({
              ...prev,
              [item?.backend_name]: []
            }));

            const product_detail_col_index = sel_productDetails?.findIndex(
              (item2) => item2?.backend_name === item?.backend_name
            );
            if (product_detail_col_index > 0) {
              const previousItem =
                    product_detail_col_index > 0
                      ? sel_productDetails[product_detail_col_index - 1]?.backend_name
                      : null;
           
                  let selecteditems = null; // Initialize the variable
      
                  if (previousItem !== null) {
                    selecteditems = sel_categories[previousItem];
                    let sel_productcols = sel_productDetails?.filter(
                      (item2) => item2?.backend_name !== item?.backend_name
                    );
                    onSelCategorySwitchBtn(previousItem, selecteditems, sel_productcols);
                  }
            } else if (product_detail_col_index === 0) {
              const nextItemList = hierarchy.slice(hierarchy.indexOf(sel_productDetails[1]?.backend_name));

              setCategories((prevCategories: All_CategoriesProps) => {
                const newCategories: All_CategoriesProps = { ...prevCategories };
        
                nextItemList.forEach((key) => {
                  if (key in newCategories) {
                    // Collect unique values for this key
                    const uniqueValues = Array.from(
                      new Set(
                          dropDownRawData?.map((item) => item[key])
                          .filter(Boolean)
                      )
                    ).map((value) => ({ value: value as string }));
                    // Replace existing array with the new unique values
                    newCategories[key] = uniqueValues;
                  }
                });
        
                return newCategories;
              });
            }
          }
          else if(sel_categories[item?.backend_name]?.length === 0){
            const product_detail_col_index = sel_productDetails?.findIndex(
              (item2) => item2?.backend_name === item?.backend_name
            );
            if(product_detail_col_index === 0){
              // let product_detials = productDetails?.map((item) => item?.backend_name);
              setCategories(dropDownformatedData);
              // updateDropDownCategories(dropDownRawData, product_detials);
            }else if(product_detail_col_index > 0){
              const previousItem =
              product_detail_col_index > 0
                ? sel_productDetails[product_detail_col_index - 1]?.backend_name
                : null;

            let selecteditems = null; // Initialize the variable

            if (previousItem !== null) {
              selecteditems = sel_categories[previousItem];
              let sel_productcols = sel_productDetails?.filter(
                (item2) => item2?.backend_name !== item?.backend_name
              );
              onSelCategorySwitchBtn(previousItem, selecteditems, sel_productcols);
            }
            }
          }
        }
        // else if(item?.toggle){
        //   if(sel_categories[item?.backend_name]?.length === 0){
            
        //   }
        // }
      });

      fetchTableData(productDetailsDrawer, matricesDataDrawer, new_product_details_hierarchy,  new_metrics_hierarchy);
      fetchTotalData(productDetailsDrawer, matricesDataDrawer);
    }
  
  }

  const [drill_through_state_arr, setDrill_Through_state_arr] = useState<{type: string; name: string }[]>([]);
  const [drillThroughJourneyModalToggle, setDrillThroughJourneyModalToggle] = useState<boolean>(false);

  const DrillThroughToggleHandler = (arr: {type: string, name: string}[]) => {
    setDrill_Through_state_arr(arr);
    setDrillThroughJourneyModalToggle(true);
  }

  const DrillThroughHandler = (name: string) => {
    let new_obj = {
      journey_name : name,
      arr: drill_through_state_arr,
      hierarchy_levels,
      dateRange: InputRange,
    }
    setDrillThroughJourneyModalToggle(false);
    const queryString = encodeURIComponent(JSON.stringify(new_obj));

    // Below Url is for Opening Drill Through Page 
    const url = `${window.location.origin}/Ads_dashboard/drill_Through/comparison/${brand_id}/${queryString}`;
    window.open(url);
    setDrillThroughJourneyModalToggle(false);

    // Below Url is For Opening Table Page
    // const url_1= `${window.location.origin}/userManagement/newtable/${brand_id}/:${queryString}`;
    // window.open(url_1);
  }

  // for Clear All Filters of Product Details Section
  const onClearAllFilter = () => {
    let new_sel_categories = {
      ad_type: [],
      campaign_name: [],
      placementclassification: [],
    };
    setSel_Categories(new_sel_categories);
    setSel_CategoriesDrawer(new_sel_categories);
  }
  const [exportSelectionToggle, setExportSelectionToggle] = useState<boolean>(false);
  const [customExportToggle, setCustomExportToggle] = useState<boolean>(false);
  const [graphTableArr, setGraphTableArr] = useState<any[]>([]);

  const onClickCellHandler = (ip_arr: any[]) => {
    setGraphTableArr(ip_arr);
  }
  // const conditonsContainerRef = useRef<HTMLDivElement | null>(null);

  // useEffect(() =>{
  //   const container = conditonsContainerRef.current;
  //   if (container) {
  //     container.scrollTop = container.scrollHeight;
  //   }
  // },[local_Cond_name, newconditionsArr, conditionToggle]);
  return (
    <>
      <div
        className="flex flex-col"
        style={{
          width: "calc(100vw - 71px)",
          // overflowY: "auto",
          height: "calc(100vh - 72px)",
        }}
      >
        <div
          className="flex py-3 px-[20px] justify-between items-center gap-1 self-stretch"
          style={{
            borderBottom: "1px solid #EAEAED",
          }}
        >
          <div className="flex items-center gap-2">
            <div
              style={{
                color: "var(--Text-Primary-Black, #1C1C1E)",
                fontFamily: "Inter",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "26px",
              }}
            >
              Placement Analysis
            </div>
            <div
              className="flex h-[40px] px-[6px] py-1 items-start rounded-[4px]"
              style={{
                backgroundColor: "#F9F9FB",
              }}
            >
              <div
                className="flex w-[100px] px-4 py-2 justify-center items-center gap-1 self-stretch rounded-[4px] cursor-pointer"
                style={{
                  backgroundColor: location.pathname.includes(
                    "/Ads_dashboard/placementAnalysis/comparison"
                  )
                    ? "#FFF"
                    : "#F9F9FB",
                  color: location.pathname.includes(
                    "/Ads_dashboard/placementAnalysis/comparison"
                  )
                    ? "#1565C0"
                    : "#97979A",
                  boxShadow: location.pathname.includes(
                    "/Ads_dashboard/placementAnalysis/comparison"
                  )
                    ? "0px 4px 16px 16px rgba(130,130,130,0.05)"
                    : "none",
                }}
                onClick={() =>
                  navigate(`/Ads_dashboard/placementAnalysis/comparison/${brand_id}`)
                }
              >
                <div
                  style={{
                    color: location.pathname.includes(
                      "/Ads_dashboard/placementAnalysis/comparison"
                    )
                      ? "var(--Text-Event-Blue, #1565C0)"
                      : "#97979A",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "10px",
                    fontStyle: "normal",
                    fontWeight: location.pathname.includes(
                      "/Ads_dashboard/placementAnalysis/comparison"
                    )
                      ? 600
                      : 500,
                    lineHeight: "10px",
                    letterSpacing: "1.6px",
                    textTransform: "uppercase",
                  }}
                >
                  COMPARISON
                </div>
              </div>
              <div
                className="flex w-[100px] px-4 py-2 justify-center items-center gap-1 self-stretch rounded-[4px] cursor-pointer"
                style={{
                  backgroundColor: location.pathname.includes(
                    "/Ads_dashboard/placementAnalysis/summary"
                  )
                    ? "#FFF"
                    : "#F9F9FB",
                  color: location.pathname.includes(
                    "/Ads_dashboard/placementAnalysis/summary"
                  )
                    ? "#1565C0"
                    : "#97979A",
                  boxShadow: location.pathname.includes(
                    "/Ads_dashboard/placementAnalysis/summary"
                  )
                    ? "0px 4px 16px 16px rgba(130,130,130,0.05)"
                    : "none",
                }}
                onClick={() =>
                  navigate(`/Ads_dashboard/placementAnalysis/summary/${brand_id}`)
                }
              >
                <div
                  style={{
                    color: location.pathname.includes(
                      "/Ads_dashboard/placementAnalysis/summary"
                    )
                      ? "var(--Text-Event-Blue, #1565C0)"
                      : "#97979A",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "10px",
                    fontStyle: "normal",
                    fontWeight: location.pathname.includes(
                      "/Ads_dashboard/placementAnalysis/summary"
                    )
                      ? 600
                      : 500,
                    lineHeight: "10px",
                    letterSpacing: "1.6px",
                    textTransform: "uppercase",
                  }}
                >
                  SUMMARY
                </div>
              </div>
            </div>
          </div>

          <div
            className="flex items-center py-2 px-4 gap-2 rounded-[4px]"
            style={{
              border: "1px solid #EAEAED",
              position: "relative",
            }}
          >
            <div className="flex items-center gap-2">
              <div
                style={{
                  color: "var(--Text-Primary-Black, #1C1C1E)",
                  fontFamily: "Inter",
                  fontSize: "10px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "14px",
                }}
              >
                {`${String(InputRange?.rangeOne?.startDate.getDate()).padStart(
                  2,
                  "0"
                )}/${String(
                  InputRange?.rangeOne?.startDate.getMonth() + 1
                ).padStart(
                  2,
                  "0"
                )}/${InputRange?.rangeOne?.startDate?.getFullYear()} - ${String(
                  InputRange?.rangeOne?.endDate.getDate()
                ).padStart(2, "0")}/${String(
                  InputRange?.rangeOne?.endDate.getMonth() + 1
                ).padStart(
                  2,
                  "0"
                )}/${InputRange?.rangeOne?.endDate?.getFullYear()} `}
              </div>
              <div
                style={{
                  color: "var(--Text-Primary-Grey, #97979A)",
                  fontFamily: "Inter",
                  fontSize: "8px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "12px",
                }}
              >
                Vs
              </div>
              <div
                style={{
                  color: "var(--Text-Primary-Black, #1C1C1E)",
                  fontFamily: "Inter",
                  fontSize: "10px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "14px",
                }}
              >
                {`${String(InputRange?.rangeTwo?.startDate.getDate()).padStart(
                  2,
                  "0"
                )}/${String(
                  InputRange?.rangeTwo?.startDate.getMonth() + 1
                ).padStart(
                  2,
                  "0"
                )}/${InputRange?.rangeTwo?.startDate?.getFullYear()} - ${String(
                  InputRange?.rangeTwo?.endDate.getDate()
                ).padStart(2, "0")}/${String(
                  InputRange?.rangeTwo?.endDate.getMonth() + 1
                ).padStart(
                  2,
                  "0"
                )}/${InputRange?.rangeTwo?.endDate?.getFullYear()} `}
              </div>
            </div>
            <img
              src={CalenderIcon}
              alt="OverView Icon"
              style={{ cursor: "pointer" }}
              onClick={() => setDateToggle(true)}
              ref={dateRangeCmpButtonRef}
            />
            {dateToggle && (
              <div
                className="absolute "
                style={{ top: "37px", right: "0px", zIndex: 100 }}
                ref={dateRangeCmpRef}
              >
                <CompareTwoDateRangeComponent
                  rangeOne={{
                    startDate: InputRange?.rangeOne?.startDate,
                    endDate: InputRange?.rangeOne?.endDate,
                  }}
                  rangeTwo={{
                    startDate: InputRange?.rangeTwo?.startDate,
                    endDate: InputRange?.rangeTwo?.endDate,
                  }}
                  apply={apply}
                  minDate={range?.min_date}
                  maxDate={range?.max_date}
                  setDateToggle={setDateToggle}
                />
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-col items-start gap-6 my-[12px]" style={{
          overflowY: "auto",
          boxShadow: "0px 4px 16px 16px rgba(130,130,130, 0.05)",
        }}>
          <div
            className="flex flex-col justify-between items-start mx-[20px] self-stretch rounded-[8px]"
            style={{
              backgroundColor: "#FFF",
              boxShadow: "0px 4px 16px 16px rgba(130,130,130, 0.05)",
              position: "relative",
            }}
          >
            <div className="flex flex-col px-3 items-start self-stretch sticky top-0 z-50">
              <div className="flex flex-col items-start gap-3 self-stretch sticky top-0 z-10">
                <div className="bg-[#FFF] py-3 flex w-full justify-between items-center sticky top-0 z-10" style={{
                  borderRadius: "8px 8px 0px 0px"
                }}>
                  <div className="flex items-center gap-2 relative">
                    <Button
                      color="neutral"
                      sx={{
                        height: 32,
                        // width: 106,
                        backgroundColor: "#FFF",
                        color: "#1C1C1E",
                        ":hover": {
                          backgroundColor: "#FFF",
                        },
                        paddingX: "12px",
                        paddingY: 0,
                        gap: "8px",
                        borderRadius: "4px",
                        border: `1px solid #EAEAED`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      onClick={() => {
                        setDrawerToggle(true);
                        setDrawerSubOption("METRICES");
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M4.42312 9.01437C4.00215 9.01437 3.64583 8.86853 3.35416 8.57687C3.0625 8.2852 2.91666 7.92888 2.91666 7.50791V4.42312C2.91666 4.00214 3.0625 3.64582 3.35416 3.35416C3.64583 3.06249 4.00215 2.91666 4.42312 2.91666H15.5769C15.9978 2.91666 16.3542 3.06249 16.6458 3.35416C16.9375 3.64582 17.0833 4.00214 17.0833 4.42312V7.50791C17.0833 7.92888 16.9375 8.2852 16.6458 8.57687C16.3542 8.86853 15.9978 9.01437 15.5769 9.01437H4.42312ZM4.42312 7.76437H15.5769C15.6517 7.76437 15.7132 7.74034 15.7612 7.69228C15.8093 7.64423 15.8333 7.58277 15.8333 7.50791V4.42312C15.8333 4.34825 15.8093 4.2868 15.7612 4.23874C15.7132 4.19068 15.6517 4.16666 15.5769 4.16666H4.42312C4.34826 4.16666 4.2868 4.19068 4.23875 4.23874C4.19069 4.2868 4.16666 4.34825 4.16666 4.42312V7.50791C4.16666 7.58277 4.19069 7.64423 4.23875 7.69228C4.2868 7.74034 4.34826 7.76437 4.42312 7.76437ZM4.42312 17.0833C4.00215 17.0833 3.64583 16.9375 3.35416 16.6458C3.0625 16.3542 2.91666 15.9978 2.91666 15.5769V12.5C2.91666 12.079 3.0625 11.7227 3.35416 11.431C3.64583 11.1394 4.00215 10.9935 4.42312 10.9935H15.5769C15.9978 10.9935 16.3542 11.1394 16.6458 11.431C16.9375 11.7227 17.0833 12.079 17.0833 12.5V15.5769C17.0833 15.9978 16.9375 16.3542 16.6458 16.6458C16.3542 16.9375 15.9978 17.0833 15.5769 17.0833H4.42312ZM4.42312 15.8333H15.5769C15.6517 15.8333 15.7132 15.8093 15.7612 15.7612C15.8093 15.7132 15.8333 15.6517 15.8333 15.5769V12.5C15.8333 12.4251 15.8093 12.3637 15.7612 12.3156C15.7132 12.2676 15.6517 12.2435 15.5769 12.2435H4.42312C4.34826 12.2435 4.2868 12.2676 4.23875 12.3156C4.19069 12.3637 4.16666 12.4251 4.16666 12.5V15.5769C4.16666 15.6517 4.19069 15.7132 4.23875 15.7612C4.2868 15.8093 4.34826 15.8333 4.42312 15.8333Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          textAlign: "center",
                          lineHeight: "18px",
                          color: "#1C1C1E",
                        }}
                      >
                        Columns
                      </div>
                    </Button>

                    <Button
                      color="neutral"
                      sx={{
                        height: 32,
                        // width: 106,
                        backgroundColor: "#FFF",
                        color: "#1C1C1E",
                        ":hover": {
                          backgroundColor: "#FFF",
                        },
                        paddingX: "12px",
                        paddingY: 0,
                        gap: "8px",
                        borderRadius: "4px",
                        border: `1px solid #EAEAED`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      onClick={onDrillUpHandler}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M15.6875 2.08073C16.3065 2.08073 16.8327 2.29809 17.266 2.73281C17.6993 3.16754 17.916 3.69538 17.916 4.31635C17.916 4.82066 17.7638 5.27073 17.4593 5.66656C17.1548 6.0624 16.7701 6.3249 16.3054 6.45406V8.37885C16.3054 8.99844 16.0864 9.52726 15.6483 9.96531C15.2103 10.4034 14.6814 10.6224 14.0618 10.6224H10.6243V13.5407C11.0891 13.6699 11.4737 13.9324 11.7781 14.3282C12.0827 14.7241 12.235 15.1741 12.235 15.6784C12.235 16.2994 12.0183 16.8273 11.585 17.262C11.1516 17.6967 10.6255 17.9141 10.0064 17.9141C9.38741 17.9141 8.85886 17.6967 8.42081 17.262C7.98275 16.8273 7.76372 16.2994 7.76372 15.6784C7.76372 15.1741 7.91602 14.7241 8.2206 14.3282C8.52504 13.9324 8.90963 13.6699 9.37435 13.5407L9.37435 10.6224L5.93685 10.6224C5.31727 10.6224 4.78845 10.4034 4.35039 9.96531C3.91234 9.52726 3.69331 8.99844 3.69331 8.37885V6.45406C3.22859 6.3249 2.84393 6.0624 2.53935 5.66656C2.23491 5.27073 2.08268 4.82066 2.08268 4.31635C2.08268 3.69538 2.30171 3.16754 2.73977 2.73281C3.17782 2.29809 3.70636 2.08073 4.32539 2.08073C4.94442 2.08073 5.4706 2.29809 5.90393 2.73281C6.33713 3.16754 6.55372 3.69538 6.55372 4.31635C6.55372 4.82066 6.4015 5.27073 6.09706 5.66656C5.79261 6.0624 5.40803 6.3249 4.94331 6.45406V8.37885C4.94331 8.66038 5.03852 8.89635 5.22893 9.08677C5.41935 9.27719 5.65532 9.3724 5.93685 9.3724H9.37435V6.45406C8.90963 6.3249 8.52504 6.0624 8.2206 5.66656C7.91602 5.27073 7.76372 4.82066 7.76372 4.31635C7.76372 3.69538 7.98275 3.16754 8.42081 2.73281C8.85886 2.29809 9.38741 2.08073 10.0064 2.08073C10.6255 2.08073 11.1516 2.29809 11.585 2.73281C12.0183 3.16754 12.235 3.69538 12.235 4.31635C12.235 4.82066 12.0827 5.27073 11.7781 5.66656C11.4737 6.0624 11.0891 6.3249 10.6243 6.45406L10.6243 9.3724L14.0618 9.3724C14.3434 9.3724 14.5793 9.27719 14.7698 9.08677C14.9602 8.89635 15.0554 8.66038 15.0554 8.37885V6.45406C14.5907 6.3249 14.2061 6.0624 13.9016 5.66656C13.5972 5.27073 13.445 4.82066 13.445 4.31635C13.445 3.69538 13.6639 3.16754 14.1018 2.73281C14.5399 2.29809 15.0684 2.08073 15.6875 2.08073ZM15.6843 3.33073C15.4082 3.33073 15.1743 3.42517 14.9825 3.61406C14.7907 3.80281 14.6948 4.03677 14.6948 4.31594C14.6948 4.5951 14.79 4.8292 14.9806 5.01823C15.171 5.2074 15.407 5.30198 15.6885 5.30198C15.962 5.30198 16.1932 5.20608 16.3823 5.01427C16.5714 4.82247 16.666 4.58983 16.666 4.31635C16.666 4.04288 16.5714 3.81024 16.3823 3.61844C16.1932 3.42663 15.9606 3.33073 15.6843 3.33073ZM10.0033 3.33073C9.7272 3.33073 9.49324 3.42517 9.30143 3.61406C9.10963 3.80281 9.01372 4.03677 9.01372 4.31594C9.01372 4.5951 9.10893 4.8292 9.29935 5.01823C9.48991 5.2074 9.72588 5.30198 10.0073 5.30198C10.2809 5.30198 10.5122 5.20608 10.7012 5.01427C10.8904 4.82247 10.985 4.58983 10.985 4.31635C10.985 4.04288 10.8904 3.81024 10.7012 3.61844C10.5122 3.42663 10.2796 3.33073 10.0033 3.33073ZM4.32227 3.33073C4.04615 3.33073 3.8122 3.42517 3.62039 3.61406C3.42859 3.80281 3.33268 4.03677 3.33268 4.31594C3.33268 4.5951 3.42789 4.8292 3.61831 5.01823C3.80873 5.2074 4.0447 5.30198 4.32623 5.30198C4.59984 5.30198 4.83115 5.20608 5.02018 5.01427C5.20935 4.82247 5.30393 4.58983 5.30393 4.31635C5.30393 4.04288 5.20935 3.81024 5.02018 3.61844C4.83115 3.42663 4.59852 3.33073 4.32227 3.33073ZM10.0033 14.6928C9.7272 14.6928 9.49324 14.7873 9.30143 14.9761C9.10963 15.1649 9.01372 15.3989 9.01372 15.678C9.01372 15.9572 9.10893 16.1913 9.29935 16.3803C9.48991 16.5695 9.72588 16.6641 10.0073 16.6641C10.2809 16.6641 10.5122 16.5682 10.7012 16.3764C10.8904 16.1845 10.985 15.9519 10.985 15.6784C10.985 15.405 10.8904 15.1723 10.7012 14.9805C10.5122 14.7887 10.2796 14.6928 10.0033 14.6928Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          textAlign: "center",
                          lineHeight: "18px",
                          color: "#1C1C1E",
                        }}
                      >
                        Drill Up
                      </div>
                    </Button>

                    <Button
                      color="neutral"
                      sx={{
                        height: 32,
                        // width: 106,
                        backgroundColor: "#FFF",
                        color: "#1C1C1E",
                        ":hover": {
                          backgroundColor: "#FFF",
                        },
                        paddingX: "12px",
                        paddingY: 0,
                        gap: "8px",
                        borderRadius: "4px",
                        border: `1px solid #EAEAED`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      onClick={onDrillDownHandler}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M4.31253 17.9193C3.6935 17.9193 3.16732 17.7019 2.73398 17.2672C2.30065 16.8325 2.08398 16.3046 2.08398 15.6836C2.08398 15.1793 2.23621 14.7293 2.54065 14.3334C2.84523 13.9376 3.22989 13.6751 3.69461 13.5459V11.6211C3.69461 11.0016 3.91364 10.4727 4.35169 10.0347C4.78975 9.59663 5.31857 9.3776 5.93815 9.3776H9.37565V6.45927C8.91093 6.3301 8.52634 6.0676 8.2219 5.67177C7.91732 5.27594 7.76503 4.82587 7.76503 4.32156C7.76503 3.70059 7.98169 3.17274 8.41503 2.73802C8.84836 2.3033 9.37454 2.08594 9.99357 2.08594C10.6126 2.08594 11.1411 2.3033 11.5792 2.73802C12.0172 3.17274 12.2363 3.70059 12.2363 4.32156C12.2363 4.82587 12.084 5.27594 11.7794 5.67177C11.475 6.0676 11.0904 6.3301 10.6257 6.45927V9.3776H14.0632C14.6827 9.3776 15.2116 9.59663 15.6496 10.0347C16.0877 10.4727 16.3067 11.0016 16.3067 11.6211V13.5459C16.7714 13.6751 17.1561 13.9376 17.4607 14.3334C17.7651 14.7293 17.9173 15.1793 17.9173 15.6836C17.9173 16.3046 17.6983 16.8325 17.2602 17.2672C16.8222 17.7019 16.2936 17.9193 15.6746 17.9193C15.0556 17.9193 14.5294 17.7019 14.0961 17.2672C13.6629 16.8325 13.4463 16.3046 13.4463 15.6836C13.4463 15.1793 13.5985 14.7293 13.9029 14.3334C14.2074 13.9376 14.592 13.6751 15.0567 13.5459V11.6211C15.0567 11.3396 14.9615 11.1036 14.7711 10.9132C14.5807 10.7228 14.3447 10.6276 14.0632 10.6276H10.6257V13.5459C11.0904 13.6751 11.475 13.9376 11.7794 14.3334C12.084 14.7293 12.2363 15.1793 12.2363 15.6836C12.2363 16.3046 12.0172 16.8325 11.5792 17.2672C11.1411 17.7019 10.6126 17.9193 9.99357 17.9193C9.37454 17.9193 8.84836 17.7019 8.41503 17.2672C7.98169 16.8325 7.76503 16.3046 7.76503 15.6836C7.76503 15.1793 7.91732 14.7293 8.2219 14.3334C8.52634 13.9376 8.91093 13.6751 9.37565 13.5459V10.6276H5.93815C5.65662 10.6276 5.42065 10.7228 5.23023 10.9132C5.03982 11.1036 4.94461 11.3396 4.94461 11.6211V13.5459C5.40933 13.6751 5.79391 13.9376 6.09836 14.3334C6.4028 14.7293 6.55503 15.1793 6.55503 15.6836C6.55503 16.3046 6.33607 16.8325 5.89815 17.2672C5.46009 17.7019 4.93155 17.9193 4.31253 17.9193ZM4.31565 16.6693C4.59176 16.6693 4.82572 16.5748 5.01753 16.3859C5.20933 16.1972 5.30523 15.9632 5.30523 15.6841C5.30523 15.4049 5.20996 15.1708 5.0194 14.9818C4.82898 14.7926 4.59301 14.698 4.31148 14.698C4.03801 14.698 3.80676 14.7939 3.61773 14.9857C3.42857 15.1775 3.33398 15.4102 3.33398 15.6836C3.33398 15.9571 3.42857 16.1898 3.61773 16.3816C3.80676 16.5734 4.0394 16.6693 4.31565 16.6693ZM9.99669 16.6693C10.2728 16.6693 10.5068 16.5748 10.6986 16.3859C10.8904 16.1972 10.9863 15.9632 10.9863 15.6841C10.9863 15.4049 10.8911 15.1708 10.7007 14.9818C10.5101 14.7926 10.2741 14.698 9.99273 14.698C9.71912 14.698 9.4878 14.7939 9.29878 14.9857C9.10961 15.1775 9.01503 15.4102 9.01503 15.6836C9.01503 15.9571 9.10961 16.1898 9.29878 16.3816C9.4878 16.5734 9.72044 16.6693 9.99669 16.6693ZM15.6777 16.6693C15.9538 16.6693 16.1878 16.5748 16.3796 16.3859C16.5714 16.1972 16.6673 15.9632 16.6673 15.6841C16.6673 15.4049 16.5721 15.1708 16.3817 14.9818C16.1913 14.7926 15.9553 14.698 15.6738 14.698C15.4002 14.698 15.1688 14.7939 14.9798 14.9857C14.7907 15.1775 14.6961 15.4102 14.6961 15.6836C14.6961 15.9571 14.7907 16.1898 14.9798 16.3816C15.1688 16.5734 15.4015 16.6693 15.6777 16.6693ZM9.99669 5.30719C10.2728 5.30719 10.5068 5.21274 10.6986 5.02385C10.8904 4.8351 10.9863 4.60115 10.9863 4.32198C10.9863 4.04281 10.8911 3.80872 10.7007 3.61969C10.5101 3.43052 10.2741 3.33594 9.99273 3.33594C9.71912 3.33594 9.4878 3.43184 9.29878 3.62365C9.10961 3.81545 9.01503 4.04809 9.01503 4.32156C9.01503 4.59503 9.10961 4.82767 9.29878 5.01948C9.4878 5.21128 9.72044 5.30719 9.99669 5.30719Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          textAlign: "center",
                          lineHeight: "18px",
                          color: "#1C1C1E",
                        }}
                      >
                        Drill Down
                      </div>
                    </Button>

                    <Button
                      color="neutral"
                      sx={{
                        height: 32,
                        // width: 106,
                        backgroundColor: "#FFF",
                        color: "#1C1C1E",
                        ":hover": {
                          backgroundColor: "#FFF",
                        },
                        paddingX: "12px",
                        paddingY: 0,
                        gap: "8px",
                        borderRadius: "4px",
                        border: `1px solid #EAEAED`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      ref={menuButtonRef}
                      onClick={() => setSortByToggle(!sortByToggle)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M7.63562 10.5378C7.4584 10.5378 7.30993 10.4779 7.19021 10.358C7.07062 10.2383 7.01083 10.0899 7.01083 9.91281V4.47052L5.07979 6.40156C4.96701 6.51698 4.82611 6.57469 4.65708 6.57469C4.48806 6.57469 4.33889 6.5149 4.20958 6.39531C4.08028 6.2649 4.01562 6.1158 4.01562 5.94802C4.01562 5.78038 4.08028 5.63191 4.20958 5.5026L7.10062 2.61156C7.17854 2.53351 7.26111 2.47851 7.34833 2.44656C7.43569 2.41448 7.52924 2.39844 7.62896 2.39844C7.72868 2.39844 7.8234 2.41455 7.91312 2.44677C8.00285 2.47913 8.08618 2.53406 8.16312 2.61156L11.075 5.52344C11.1989 5.64733 11.26 5.79101 11.2583 5.95448C11.2568 6.11795 11.1914 6.2649 11.0621 6.39531C10.9328 6.5149 10.7864 6.57684 10.6229 6.58115C10.4594 6.58531 10.3131 6.52281 10.184 6.39365L8.26083 4.47052V9.92073C8.26083 10.0956 8.2009 10.2421 8.08104 10.3603C7.96118 10.4786 7.81271 10.5378 7.63562 10.5378ZM12.3702 17.5955C12.2705 17.5955 12.1758 17.5793 12.086 17.547C11.9963 17.5148 11.913 17.4599 11.836 17.3824L8.92417 14.4705C8.80028 14.3465 8.73917 14.2028 8.74083 14.0395C8.74236 13.876 8.80778 13.7291 8.93708 13.5986C9.06639 13.4791 9.21278 13.4171 9.37625 13.4128C9.53972 13.4085 9.68604 13.471 9.81521 13.6003L11.7383 15.5234V10.073C11.7383 9.8983 11.7983 9.75177 11.9181 9.63344C12.038 9.51524 12.1865 9.45615 12.3635 9.45615C12.5408 9.45615 12.6892 9.51601 12.809 9.63573C12.9285 9.75559 12.9883 9.90406 12.9883 10.0811V15.5234L14.9194 13.5922C15.0322 13.4769 15.1731 13.4193 15.3421 13.4193C15.5111 13.4193 15.6603 13.4791 15.7896 13.5986C15.9189 13.7291 15.9835 13.8781 15.9835 14.0457C15.9835 14.2135 15.9189 14.362 15.7896 14.4914L12.8985 17.3824C12.8206 17.4603 12.7381 17.5153 12.6508 17.5474C12.5635 17.5795 12.4699 17.5955 12.3702 17.5955Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          textAlign: "center",
                          lineHeight: "18px",
                          color: "#1C1C1E",
                        }}
                      >
                        Sort
                      </div>
                    </Button>
                    {sortByToggle && (
                      <div
                        className="absolute h-[224px] w-[240px] top-10 left-[336px] rounded-[8px] inline-flex py-2 flex-col justify-center items-start"
                        style={{
                          backgroundColor: "#FFF",
                          boxShadow: "0px 4px 10px 4px rgba(28,28,30,0.05)",
                          zIndex: 100,
                        }}
                        ref={menuRef}
                      >
                        {sortValues?.length > 0 &&
                          sortValues?.map((value) => (
                            <div
                              className="flex w-full h-[52px] p-4 justify-between items-center cursor-pointer"
                              key={value}
                              onClick={() => {
                                setSort((prev) => ({
                                  ...prev,
                                  sort_by: value,
                                }));
                                setSortByToggle(false);
                              }}
                            >
                              <div
                                style={{
                                  color: "var(--Text-Primary-Black, #1C1C1E)",
                                  fontSize: "14px",
                                  fontFamily: "Inter",
                                  fontStyle: "normal",
                                  fontWeight:
                                    sort?.sort_by === value ? 600 : 400,
                                  lineHeight: "18px",
                                }}
                              >
                                {`Sort By ${
                                  value === "current"
                                    ? "Current Value"
                                    : value === "previous"
                                    ? "Comparison Value"
                                    : value === "difference"
                                    ? "Difference Value"
                                    : "Difference Percentage"
                                }`}
                              </div>
                            </div>
                          ))}
                      </div>
                    )}
                    <div className="w-fit">
                      <MultiSelectFilterComponent
                        children={filterLists}
                        selected={selectedFilterLists}
                        onChange={onFilterListChange}
                      />
                    </div>

                    <Button
                      color="neutral"
                      sx={{
                        height: 32,
                        // width: 106,
                        backgroundColor: "#FFF",
                        color: "#1C1C1E",
                        ":hover": {
                          backgroundColor: "#FFF",
                        },
                        paddingX: "12px",
                        paddingY: 0,
                        gap: "8px",
                        borderRadius: "4px",
                        border: `1px solid #EAEAED`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      onClick={onClearAllFilter}
                    >
                      {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M4.31253 17.9193C3.6935 17.9193 3.16732 17.7019 2.73398 17.2672C2.30065 16.8325 2.08398 16.3046 2.08398 15.6836C2.08398 15.1793 2.23621 14.7293 2.54065 14.3334C2.84523 13.9376 3.22989 13.6751 3.69461 13.5459V11.6211C3.69461 11.0016 3.91364 10.4727 4.35169 10.0347C4.78975 9.59663 5.31857 9.3776 5.93815 9.3776H9.37565V6.45927C8.91093 6.3301 8.52634 6.0676 8.2219 5.67177C7.91732 5.27594 7.76503 4.82587 7.76503 4.32156C7.76503 3.70059 7.98169 3.17274 8.41503 2.73802C8.84836 2.3033 9.37454 2.08594 9.99357 2.08594C10.6126 2.08594 11.1411 2.3033 11.5792 2.73802C12.0172 3.17274 12.2363 3.70059 12.2363 4.32156C12.2363 4.82587 12.084 5.27594 11.7794 5.67177C11.475 6.0676 11.0904 6.3301 10.6257 6.45927V9.3776H14.0632C14.6827 9.3776 15.2116 9.59663 15.6496 10.0347C16.0877 10.4727 16.3067 11.0016 16.3067 11.6211V13.5459C16.7714 13.6751 17.1561 13.9376 17.4607 14.3334C17.7651 14.7293 17.9173 15.1793 17.9173 15.6836C17.9173 16.3046 17.6983 16.8325 17.2602 17.2672C16.8222 17.7019 16.2936 17.9193 15.6746 17.9193C15.0556 17.9193 14.5294 17.7019 14.0961 17.2672C13.6629 16.8325 13.4463 16.3046 13.4463 15.6836C13.4463 15.1793 13.5985 14.7293 13.9029 14.3334C14.2074 13.9376 14.592 13.6751 15.0567 13.5459V11.6211C15.0567 11.3396 14.9615 11.1036 14.7711 10.9132C14.5807 10.7228 14.3447 10.6276 14.0632 10.6276H10.6257V13.5459C11.0904 13.6751 11.475 13.9376 11.7794 14.3334C12.084 14.7293 12.2363 15.1793 12.2363 15.6836C12.2363 16.3046 12.0172 16.8325 11.5792 17.2672C11.1411 17.7019 10.6126 17.9193 9.99357 17.9193C9.37454 17.9193 8.84836 17.7019 8.41503 17.2672C7.98169 16.8325 7.76503 16.3046 7.76503 15.6836C7.76503 15.1793 7.91732 14.7293 8.2219 14.3334C8.52634 13.9376 8.91093 13.6751 9.37565 13.5459V10.6276H5.93815C5.65662 10.6276 5.42065 10.7228 5.23023 10.9132C5.03982 11.1036 4.94461 11.3396 4.94461 11.6211V13.5459C5.40933 13.6751 5.79391 13.9376 6.09836 14.3334C6.4028 14.7293 6.55503 15.1793 6.55503 15.6836C6.55503 16.3046 6.33607 16.8325 5.89815 17.2672C5.46009 17.7019 4.93155 17.9193 4.31253 17.9193ZM4.31565 16.6693C4.59176 16.6693 4.82572 16.5748 5.01753 16.3859C5.20933 16.1972 5.30523 15.9632 5.30523 15.6841C5.30523 15.4049 5.20996 15.1708 5.0194 14.9818C4.82898 14.7926 4.59301 14.698 4.31148 14.698C4.03801 14.698 3.80676 14.7939 3.61773 14.9857C3.42857 15.1775 3.33398 15.4102 3.33398 15.6836C3.33398 15.9571 3.42857 16.1898 3.61773 16.3816C3.80676 16.5734 4.0394 16.6693 4.31565 16.6693ZM9.99669 16.6693C10.2728 16.6693 10.5068 16.5748 10.6986 16.3859C10.8904 16.1972 10.9863 15.9632 10.9863 15.6841C10.9863 15.4049 10.8911 15.1708 10.7007 14.9818C10.5101 14.7926 10.2741 14.698 9.99273 14.698C9.71912 14.698 9.4878 14.7939 9.29878 14.9857C9.10961 15.1775 9.01503 15.4102 9.01503 15.6836C9.01503 15.9571 9.10961 16.1898 9.29878 16.3816C9.4878 16.5734 9.72044 16.6693 9.99669 16.6693ZM15.6777 16.6693C15.9538 16.6693 16.1878 16.5748 16.3796 16.3859C16.5714 16.1972 16.6673 15.9632 16.6673 15.6841C16.6673 15.4049 16.5721 15.1708 16.3817 14.9818C16.1913 14.7926 15.9553 14.698 15.6738 14.698C15.4002 14.698 15.1688 14.7939 14.9798 14.9857C14.7907 15.1775 14.6961 15.4102 14.6961 15.6836C14.6961 15.9571 14.7907 16.1898 14.9798 16.3816C15.1688 16.5734 15.4015 16.6693 15.6777 16.6693ZM9.99669 5.30719C10.2728 5.30719 10.5068 5.21274 10.6986 5.02385C10.8904 4.8351 10.9863 4.60115 10.9863 4.32198C10.9863 4.04281 10.8911 3.80872 10.7007 3.61969C10.5101 3.43052 10.2741 3.33594 9.99273 3.33594C9.71912 3.33594 9.4878 3.43184 9.29878 3.62365C9.10961 3.81545 9.01503 4.04809 9.01503 4.32156C9.01503 4.59503 9.10961 4.82767 9.29878 5.01948C9.4878 5.21128 9.72044 5.30719 9.99669 5.30719Z"
                          fill="#1C1C1E"
                        />
                      </svg> */}
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          textAlign: "center",
                          lineHeight: "18px",
                          color: "#1C1C1E",
                        }}
                      >
                        Clear Filter
                      </div>
                    </Button>                    
                  </div>

                  <div className="flex h-[32px] items-center gap-2">
                    <div
                      className="flex justify-between w-[200px] px-4 py-2 items-center gap-2 self-stretch rounded-[4px] h-fit relative"
                      style={{
                        border: "1px solid #EAEAED",
                      }}
                    >
                      <input
                        type="text"
                        name=""
                        className="w=[70%] h-[16px]"
                        placeholder={`Search by ${searchobj?.frontend_value_type}`}
                        value={searchobj?.value}
                        onChange={onSearchvalueInputChange}
                        style={{
                          fontSize: "12px",
                          fontWeight: searchobj?.value ? 500 : 400,
                          lineHeight: "18px",
                          outline: "none",
                        }}
                      />
                      <img
                        src={ThreeDotIcon}
                        alt="Icon"
                        style={{ cursor: "pointer" }}
                        ref={FilterButtonRef}
                        onClick={() => {
                          setSearchobjToggle(!searchobjToggle);
                          setSearchFocus(false);
                        }}
                      />

                      {searchobjToggle && !searchFocus && (
                        <div
                          ref={FilterRef}
                          className="absolute top-[37px] left-0 h-[242px] flex w-[200px] px-0 py-2 flex-col items-start rounded-[8px]"
                          style={{
                            backgroundColor: "#FFF",
                            boxShadow: "0px 4px 10px 4px rgba(28,28,30,0.05)",
                            zIndex: 100,
                            overflowY: "auto",
                          }}
                        >
                          <div className="flex px-4 py-2 justify-start items-center gap-1 self-stretch">
                            <div
                              style={{
                                color: "var(--Text-Primary-Grey, #97979A)",
                                fontFamily: "Inter",
                                fontSize: "10px",
                                fontStyle: "normal",
                                fontWeight: 500,
                                lineHeight: "10px",
                                letterSpacing: "1.6px",
                                textTransform: "uppercase",
                                textAlign: "start",
                              }}
                            >
                              Search By
                            </div>
                          </div>

                          {searchobjtypeArr?.length > 0 &&
                            searchobjtypeArr.map((value) => (
                              <div
                                style={{
                                  display: "flex",
                                  height: "52px",
                                  padding: "16px",
                                  alignItems: "center",
                                  gap: "8px",
                                  alignSelf: "stretch",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setSearchObj((prev) => ({
                                    value: "",
                                    frontend_value_type: value?.detail_name,
                                    backend_value_type: value?.backend_name,
                                  }));
                                  const isAnyArrayNotEmpty = Object.values(sel_categories).some(arr => arr.length > 0);
                                  if(isAnyArrayNotEmpty){
                                    let new_obj_state = {
                                      ad_type: [],
                                      campaign_name: [],
                                      placementclassification: [],
                                    };
                                    setSel_Categories(new_obj_state);
                                    setSel_CategoriesDrawer(new_obj_state);
                                  }
                                  setSearchobjToggle(false);
                                }}
                              >
                                <div
                                  style={{
                                    color: "var(--Text-Primary-Black, #1C1C1E)",
                                    fontFamily: "Inter",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight:
                                      searchobj?.backend_value_type ===
                                      value?.backend_name
                                        ? 600
                                        : 400,
                                    lineHeight: "18px",
                                  }}
                                >
                                  {value?.detail_name}
                                </div>
                              </div>
                            ))}
                        </div>
                      )}
                      {searchFocus && !searchobjToggle && (
                        <div
                          style={{
                            position: "absolute",
                            top: 37,
                            left: 0,
                            width: 200,
                            maxHeight: 242,
                            borderRadius: "8px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            borderBottom: `1px solid ${BLACK.B_10}`,
                            borderLeft: `1px solid ${BLACK.B_10}`,
                            borderRight: `1px solid ${BLACK.B_10}`,
                            backgroundColor: WHITE.W_100,
                            zIndex: 100,
                            boxShadow: "0px 4px 10px 4px rgba(28,28,30,0.05)",
                          }}
                        >
                          <div
                            style={{
                              width: 200,
                              flex: 1,
                              paddingTop: 8,
                              paddingBottom: 8,
                              maxHeight: 242,
                              overflow: "auto",
                            }}
                          >
                            {searchFileArray?.map((obj) => {
                              return (
                                <div
                                  key={obj?.value}
                                  onClick={() =>
                                    onSearchValueChange(obj?.value)
                                  }
                                  style={{
                                    display: "flex",
                                    padding: "16px",
                                    alignItems: "center",
                                    gap: "8px",
                                    alignSelf: "stretch",
                                    cursor: "pointer",
                                    width: 194,
                                  }}
                                >
                                  <div
                                    style={{
                                      color:
                                        "var(--Text-Primary-Black, #1C1C1E)",
                                      fontFamily: "Inter",
                                      fontSize: "14px",
                                      fontStyle: "normal",
                                      fontWeight:
                                        searchobj?.value === obj?.value
                                          ? 600
                                          : 400,
                                      lineHeight: "18px",
                                      width: "100%",
                                      textWrap: "wrap",
                                      overflowWrap: "break-word",
                                    }}
                                  >
                                    {obj?.value}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </div>

                    <Button
                      sx={{
                        backgroundColor: "#FFF",
                        ":hover": {
                          backgroundColor: "#FFF",
                        },
                        borderRadius: "4px",
                        paddingX: "12px",
                        paddingY: "0px",
                        border: `1px solid #EAEAED`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <div
                        className=""
                        style={{
                          color: "#1C1C1E",
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "600",
                          lineHeight: "18px",
                        }}
                      >
                        View Graph
                      </div>
                      <img
                        src={GraphIcon}
                        alt="Graph Icon"
                        style={{ cursor: "pointer" }}
                        // onClick={() => setDateToggle(true)}
                      />
                    </Button>

                    <div className=""
                    style={{
                      position: 'relative'
                    }}>
                      <Button
                        sx={{
                          backgroundColor: "#FFF",
                          ":hover": {
                            backgroundColor: "#FFF",
                          },
                          borderRadius: "6px",
                          paddingX: "6px",
                          paddingY: "0px",
                          border: `1px solid #EAEAED`,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        ref={exportButtonRef}
                        onClick={() => setExportToggle(prev => !prev)}
                      >
                        <img
                          src={ExportIcon}
                          alt="Export Icon"
                          style={{ cursor: "pointer" }}
                        />
                      </Button>
                      {exportToggle && (
                        <div className="" style={{
                          position: "absolute",
                          top: 42, 
                          right: 0,
                          height: 100,
                          width: 150,
                          backgroundColor: "#FFF",
                          boxShadow: "0px 4px 16px 16px rgba(130,130,130, 0.05)",
                          borderRadius: "8px",
                          display: 'flex',
                          flexDirection: 'column',
                          zIndex: 50
                        }}
                        ref={exportRef}
                        >
                          <div className="p-4"
                          style={{
                            color: "#1C1C1E",
                            textAlign: "start",
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "18px",
                            fontFamily: "Inter",
                            cursor: 'pointer'
                          }}
                          onClick={() => {
                            setExportToggle(false);
                            setExportSelectionToggle(true);
                          }}>
                            Export Selection
                          </div>
                          <div className="p-4"
                          style={{
                            color: "#1C1C1E",
                            textAlign: "start",
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "18px",
                            fontFamily: "Inter",
                            cursor: 'pointer'
                          }} onClick={() => {
                            setExportToggle(false);
                            setCustomExportToggle(true);
                          }}>
                            Custom Export
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ConditionCompCmp
              local_Cond_name={local_Cond_name}
              setlocal_Cond_name={setlocal_Cond_name}
              setlocal_Cond_id={setlocal_Cond_id}

              conditionsArr={conditionsArr} 
              setConditionsArr={setConditionsArr}
              localconditions={localconditions}
              setLocalConditions={setLocalConditions}
              newconditionsArr={newconditionsArr}
              setNewConditionsArr={setNewConditionsArr}
              matricsArr={matricsArr}
              parameterArr={parameterArr}
              operationsArr={operationsArr}
              listarr={listarr}

              conditionToggle={conditionToggle}
              page_name="ADS_PLACEMENT_ANALYSIS_COMPARISON"
              ClearAll={ClearAll}
              setConditionToggle={setConditionToggle}
              isDbDataChanges={isDbDataChanges}
              setIsDbDataChanges={setIsDbDataChanges}
              setSaveConditionToggle={setSaveConditionToggle}
              temp_list_name={temp_list_name}
              setTemp_List_name={setTemp_List_name}
              createConditionLists={createConditionLists}
              saveConditionToggle={saveConditionToggle}
              conditonsSave={conditonsSave}
              setConfirmConditionToggle={setConfirmConditionToggle}
              />

            <div className="flex flex-col px-3 items-start self-stretch">
              <div className="h-[56px] flex items-center justify-end gap-4 self-stretch">
                <div
                  className="flex h-[32px] px-[4px] py-[2px] items-start rounded-[4px] "
                  style={{
                    backgroundColor: "#F9F9FB",
                  }}
                >
                  <div
                    style={{
                      backgroundColor:
                        valueFilter === "VALUE" ? "#FFF" : "#F9F9FB",
                      display: "flex",
                      padding: "8px 16px",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "4px",
                      alignSelf: "stretch",
                      borderRadius: "4px",
                      boxShadow:
                        valueFilter === "VALUE"
                          ? "0px 4px 16px 6px rgba(130, 130, 130, 0.05)"
                          : "none",
                    }}
                    onClick={() => setValueFilter("VALUE")}
                  >
                    <div
                      style={{
                        color:
                          valueFilter === "VALUE"
                            ? "#1565C0"
                            : "var(--Text-Primary-Grey, #97979A)",
                        textAlign: "center",
                        fontFamily: "Inter, sans-serif",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: valueFilter === "VALUE" ? 600 : 500,
                        lineHeight: "10px", // 100%
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      {/* Content goes here */}
                      Value
                    </div>
                  </div>

                  <div
                    style={{
                      backgroundColor:
                        valueFilter === "SHARE" ? "#FFF" : "#F9F9FB",
                      display: "flex",
                      padding: "8px 16px",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "4px",
                      alignSelf: "stretch",
                      borderRadius: "4px",
                      boxShadow:
                        valueFilter === "SHARE"
                          ? "0px 4px 16px 6px rgba(130, 130, 130, 0.05)"
                          : "none",
                    }}
                    onClick={() => setValueFilter("SHARE")}
                  >
                    <div
                      style={{
                        color:
                          valueFilter === "SHARE"
                            ? "#1565C0"
                            : "var(--Text-Primary-Grey, #97979A)",
                        textAlign: "center",
                        fontFamily: "Inter, sans-serif",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: valueFilter === "SHARE" ? 600 : 500,
                        lineHeight: "10px", // 100%
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      {/* Content goes here */}% Share
                    </div>
                  </div>

                  <div
                    style={{
                      backgroundColor:
                        valueFilter === "AVERAGE" ? "#FFF" : "#F9F9FB",
                      display: "flex",
                      padding: "8px 16px",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "4px",
                      alignSelf: "stretch",
                      borderRadius: "4px",
                      boxShadow:
                        valueFilter === "AVERAGE"
                          ? "0px 4px 16px 6px rgba(130, 130, 130, 0.05)"
                          : "none",
                    }}
                    onClick={() => setValueFilter("AVERAGE")}
                  >
                    <div
                      style={{
                        color:
                          valueFilter === "AVERAGE"
                            ? "#1565C0"
                            : "var(--Text-Primary-Grey, #97979A)",
                        textAlign: "center",
                        fontFamily: "Inter, sans-serif",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: valueFilter === "AVERAGE" ? 600 : 500,
                        lineHeight: "10px", // 100%
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      {/* Content goes here */}
                      Average
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="w-[100%]"
              style={{
                minHeight: "calc(100vh - 324px)",
              }}
            >
              {loading ? (
                <div
                  className="flex justify-center items-center"
                  style={{
                    height: "calc(100vh - 72px - 251px)",
                    width: "100%",
                  }}
                >
                  <CircularProgress />
                </div>
              ) : (
                <div
                  className="w-[100%]"
                  style={{
                    height: "100%",
                  }}
                >
                  {datafetchingState === "SUCCESS" &&
                    resultDataArr?.length > 0 && Total_data?.length > 0 && (
                      <>
                        <UpdatedComparisonTable
                          setSort={setSort}
                          sort={sort}
                          data={resultDataArr}
                          headerdata={sel_headers}
                          column={sel_metricsHeaderData}
                          parameters_hierarchy={parameters_hierarchy}
                          sel_parameters={sel_parameters}
                          // products_details_hierarchy={hierarchy}
                          categories={categories}
                          setCategories={setCategories}
                          sel_categories={sel_categories}
                          sel_categoriesdrawer={sel_categoriesdrawer}
                          setSel_Categories={setSel_CategoriesDrawer}
                          subTotaldata={Total_data}
                          positive_values={positive_values}
                          negative_values={negative_values}
                          metrics_row_data={metrics_row_data}
                          onSelCategory={onSelCategory}
                          DropDownApplyBtn={DropDownApplyBtn}
                          DrillThroughHandler={DrillThroughToggleHandler}
                          cellClickHandler={onClickCellHandler}
                        />

                        {/* ---------------------Pagination Component------------------  */}
                        <div
                          className="flex justify-between items-center px-4"
                          style={{
                            borderTop: `1px solid ${BLACK.B_5}`,
                            height: 60,
                            borderBottomLeftRadius: 12,
                            borderBottomRightRadius: 12,
                          }}
                        >
                          <div className="flex items-center">
                            <div
                              className="mr-2"
                              style={{
                                fontSize: 12,
                                fontWeight: 400,
                                lineHeight: "18px",
                              }}
                            >
                              Rows per page:
                            </div>
                            <Select
                              //  onChange={(e1, e2) => onSelectChangeHandler(e1, e2, "status")}
                              onChange={(e, limit) =>
                                setPagination((prevState) => ({
                                  page: 1,
                                  limit: limit ? limit : 0 * 1,
                                }))
                              }
                              // placeholder="Select State"
                              name="status"
                              value={pagination?.limit}
                              indicator={
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                >
                                  <path
                                    d="M9.56251 12.0625L6.54167 9.04171C6.50001 9.00004 6.46876 8.9549 6.44792 8.90629C6.42709 8.85768 6.41667 8.8056 6.41667 8.75004C6.41667 8.63893 6.45487 8.54171 6.53126 8.45837C6.60764 8.37504 6.70834 8.33337 6.83334 8.33337H13.1667C13.2917 8.33337 13.3924 8.37504 13.4688 8.45837C13.5451 8.54171 13.5833 8.63893 13.5833 8.75004C13.5833 8.77782 13.5417 8.87504 13.4583 9.04171L10.4375 12.0625C10.3681 12.132 10.2986 12.1806 10.2292 12.2084C10.1597 12.2362 10.0833 12.25 10 12.25C9.91667 12.25 9.84028 12.2362 9.77084 12.2084C9.70139 12.1806 9.63195 12.132 9.56251 12.0625Z"
                                    fill="#1C1C1C"
                                    fill-opacity="0.8"
                                  />
                                </svg>
                              }
                              sx={{
                                "--Input-focusedThickness": "0px",
                                width: "80px",
                                height: "28px",
                                backgroundColor: WHITE.W_100,
                                color: BLACK.B_80,
                                fontSize: 14,
                                fontWeight: 400,
                                lineHeight: "20px",
                                border: `1px solid ${BLACK.B_10}`,
                                [`& .${selectClasses.indicator}`]: {
                                  transition: "0.2s",
                                  [`&.${selectClasses.expanded}`]: {
                                    transform: "rotate(-180deg)",
                                  },
                                },
                              }}
                            >
                              <Option value={50}>50</Option>
                              <Option value={100}>100</Option>
                              <Option value={150}>150</Option>
                            </Select>
                          </div>
                          {/* ---------------------Pagination Component------------------ */}
                          <PaginationComponent
                            page={pagination?.page}
                            limit={pagination?.limit}
                            totalRows={maxCount}
                            onChange={(page) =>
                              setPagination((prevState) => ({
                                ...prevState,
                                page,
                              }))
                            }
                          /> 
                          {/* ---------------------Pagination Component------------------*/}
                        </div>
                      </>
                    )}
                  {datafetchingState === "EMPTY" && (
                    <>
                                        <ComparisonTableEmpty
                                              setSort={setSort}
                                              sort={sort}
                                              headerdata={sel_headers}
                                              column={sel_metricsHeaderData}
                                              categories={categories}
                                              setCategories={setCategories}
                                              sel_categories={sel_categories}
                                              sel_categoriesdrawer={sel_categoriesdrawer}
                                              setSel_Categories={setSel_CategoriesDrawer}
                                              onSelCategory={onSelCategory}
                                              DropDownApplyBtn={DropDownApplyBtn}
                                            />
                                            {/* ---------------------Pagination Component------------------  */}
                                            <div
                                              className="flex justify-between items-center px-4"
                                              style={{
                                                borderTop: `1px solid ${BLACK.B_5}`,
                                                height: 60,
                                                borderBottomLeftRadius: 12,
                                                borderBottomRightRadius: 12,
                                              }}
                                            >
                                              <div className="flex items-center">
                                                <div
                                                  className="mr-2"
                                                  style={{
                                                    fontSize: 12,
                                                    fontWeight: 400,
                                                    lineHeight: "18px",
                                                  }}
                                                >
                                                  Rows per page:
                                                </div>
                                                <Select
                                                  //  onChange={(e1, e2) => onSelectChangeHandler(e1, e2, "status")}
                                                  onChange={(e, limit) =>
                                                    setPagination((prevState) => ({
                                                      page: 1,
                                                      limit: limit ? limit : 0 * 1,
                                                    }))
                                                  }
                                                  // placeholder="Select State"
                                                  name="status"
                                                  value={pagination?.limit}
                                                  indicator={
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="20"
                                                      height="20"
                                                      viewBox="0 0 20 20"
                                                      fill="none"
                                                    >
                                                      <path
                                                        d="M9.56251 12.0625L6.54167 9.04171C6.50001 9.00004 6.46876 8.9549 6.44792 8.90629C6.42709 8.85768 6.41667 8.8056 6.41667 8.75004C6.41667 8.63893 6.45487 8.54171 6.53126 8.45837C6.60764 8.37504 6.70834 8.33337 6.83334 8.33337H13.1667C13.2917 8.33337 13.3924 8.37504 13.4688 8.45837C13.5451 8.54171 13.5833 8.63893 13.5833 8.75004C13.5833 8.77782 13.5417 8.87504 13.4583 9.04171L10.4375 12.0625C10.3681 12.132 10.2986 12.1806 10.2292 12.2084C10.1597 12.2362 10.0833 12.25 10 12.25C9.91667 12.25 9.84028 12.2362 9.77084 12.2084C9.70139 12.1806 9.63195 12.132 9.56251 12.0625Z"
                                                        fill="#1C1C1C"
                                                        fill-opacity="0.8"
                                                      />
                                                    </svg>
                                                  }
                                                  sx={{
                                                    "--Input-focusedThickness": "0px",
                                                    width: "80px",
                                                    height: "28px",
                                                    backgroundColor: WHITE.W_100,
                                                    color: BLACK.B_80,
                                                    fontSize: 14,
                                                    fontWeight: 400,
                                                    lineHeight: "20px",
                                                    border: `1px solid ${BLACK.B_10}`,
                                                    [`& .${selectClasses.indicator}`]: {
                                                      transition: "0.2s",
                                                      [`&.${selectClasses.expanded}`]: {
                                                        transform: "rotate(-180deg)",
                                                      },
                                                    },
                                                  }}
                                                >
                                                  <Option value={50}>50</Option>
                                                  <Option value={100}>100</Option>
                                                  <Option value={150}>150</Option>
                                                </Select>
                                              </div>
                                              <PaginationComponent
                                                page={pagination?.page}
                                                limit={pagination?.limit}
                                                totalRows={maxCount}
                                                onChange={(page) =>
                                                  setPagination((prevState) => ({
                                                    ...prevState,
                                                    page,
                                                  }))
                                                }
                                              />
                                              {/* ---------------------Pagination Component------------------*/}
                                            </div>
                                          </>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Drawer
        key={"right"}
        anchor={"right"}
        open={drawerToggle}
        size="md"
        slotProps={{
          backdrop: {
            sx: {
              backdropFilter: "none", // Disable the blur effect
            },
          },
        }}
      >
        <div
          className="flex p-4 items-center justify-between gap-10"
          style={{
            height: 52,
            borderBottom: `1px solid #EAEAED`,
            backgroundColor: "white",
          }}
        >
          <div
            className="self-stretch"
            style={{
              fontSize: 18,
              fontWeight: 500,
              lineHeight: "24px",
              color: BLACK.B_100,
            }}
          >
            Columns
          </div>
          <div className="flex justify-between items-center gap-2">
            {/* <div
              className="flex py-1 justify-center items-center gap-2"
              style={{
                backgroundColor: "#FFF",
                cursor: "pointer"
              }}
              onClick={onResetColumnsHandler}
            >
              <div
                style={{
                  color: resetToggle ? "#1565C0" : "#B7B7B9",
                  textAlign: "center",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: 700,
                  lineHeight: "18px",
                }}
              >
                Reset Columns
              </div>
            </div> */}
            <div
              className="w-fit cursor-pointer"
              onClick={() =>{
                setProductDetailsDrawer([...productDetails]);
                setParametersDataDrawer([...parametersData]);
                setMatricesDataDrawer([...matricesData]);
                setDrawerToggle(false)
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M19.2806 18.2194C19.3502 18.289 19.4055 18.3718 19.4432 18.4628C19.4809 18.5539 19.5003 18.6514 19.5003 18.75C19.5003 18.8485 19.4809 18.9461 19.4432 19.0372C19.4055 19.1282 19.3502 19.2109 19.2806 19.2806C19.2109 19.3503 19.1281 19.4056 19.0371 19.4433C18.9461 19.481 18.8485 19.5004 18.7499 19.5004C18.6514 19.5004 18.5538 19.481 18.4628 19.4433C18.3717 19.4056 18.289 19.3503 18.2193 19.2806L11.9999 13.0603L5.78055 19.2806C5.63982 19.4213 5.44895 19.5004 5.24993 19.5004C5.05091 19.5004 4.86003 19.4213 4.7193 19.2806C4.57857 19.1399 4.49951 18.949 4.49951 18.75C4.49951 18.551 4.57857 18.3601 4.7193 18.2194L10.9396 12L4.7193 5.78061C4.57857 5.63988 4.49951 5.44901 4.49951 5.24999C4.49951 5.05097 4.57857 4.8601 4.7193 4.71936C4.86003 4.57863 5.05091 4.49957 5.24993 4.49957C5.44895 4.49957 5.63982 4.57863 5.78055 4.71936L11.9999 10.9397L18.2193 4.71936C18.36 4.57863 18.5509 4.49957 18.7499 4.49957C18.949 4.49957 19.1398 4.57863 19.2806 4.71936C19.4213 4.8601 19.5003 5.05097 19.5003 5.24999C19.5003 5.44901 19.4213 5.63988 19.2806 5.78061L13.0602 12L19.2806 18.2194Z"
                  fill="#1C1C1C"
                />
              </svg>
            </div>
          </div>
        </div>
        <DialogContent sx={{ backgroundColor: WHITE.W_100 }}>
          <div className="flex h-full w-full p-4 flex-col items-start self-stretch">
            <div className="flex flex-col items-start gap-4 self-stretch">
              {/* Product Details */}
              <div
                className="flex flex-col items-start gap-4 self-stretch rounded-[4px]"
                style={{
                  border: "1px solid #EAEAED",
                }}
              >
                <div
                  className="flex items-start self-stretch rounded-[4px] cursor-pointer"
                  style={{
                    borderBottom:
                      drawerSubOption === "PRODUCT_DETAILS"
                        ? "1px solid #EAEAED"
                        : "0px",
                  }}
                  onClick={() => {
                    if (drawerSubOption === "PRODUCT_DETAILS") {
                      setDrawerSubOption("");
                    } else {
                      setDrawerSubOption("PRODUCT_DETAILS");
                    }
                  }}
                >
                  <div className="flex h-[44px] w-full justify-between px-4 py-2 items-center gap-2 ">
                    <div
                      style={{
                        color: "var(--Text-Primary-Black, #1C1C1E)",
                        fontFamily: "Inter",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "10px", // 100%
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      Product Details
                    </div>
                    {drawerSubOption === "PRODUCT_DETAILS" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M6.83366 11.6667C6.70866 11.6667 6.60796 11.625 6.53158 11.5417C6.45519 11.4583 6.41699 11.3611 6.41699 11.25C6.41699 11.2222 6.45866 11.125 6.54199 10.9583L9.56283 7.9375C9.63227 7.86806 9.70171 7.81944 9.77116 7.79167C9.8406 7.76389 9.91699 7.75 10.0003 7.75C10.0837 7.75 10.16 7.76389 10.2295 7.79167C10.2989 7.81944 10.3684 7.86806 10.4378 7.9375L13.4587 10.9583C13.5003 11 13.5316 11.0451 13.5524 11.0938C13.5732 11.1424 13.5837 11.1944 13.5837 11.25C13.5837 11.3611 13.5455 11.4583 13.4691 11.5417C13.3927 11.625 13.292 11.6667 13.167 11.6667H6.83366Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.56234 12.0625L6.5415 9.04167C6.49984 9 6.46859 8.95486 6.44775 8.90625C6.42692 8.85764 6.4165 8.80556 6.4165 8.75C6.4165 8.63889 6.4547 8.54167 6.53109 8.45834C6.60748 8.375 6.70817 8.33334 6.83317 8.33334H13.1665C13.2915 8.33334 13.3922 8.375 13.4686 8.45834C13.545 8.54167 13.5832 8.63889 13.5832 8.75C13.5832 8.77778 13.5415 8.875 13.4582 9.04167L10.4373 12.0625C10.3679 12.1319 10.2984 12.1806 10.229 12.2083C10.1596 12.2361 10.0832 12.25 9.99984 12.25C9.9165 12.25 9.84012 12.2361 9.77067 12.2083C9.70123 12.1806 9.63178 12.1319 9.56234 12.0625Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                    )}
                  </div>
                </div>
                {drawerSubOption === "PRODUCT_DETAILS" && (
                  <div className="flex flex-col items-start self-stretch">
                    {productDetailsDrawer.length > 0 &&
                      productDetailsDrawer.map((p: ProductDetailsProps) => (
                        <div
                          className="flex justify-between items-center h-[40px] p-4 gap-2 self-stretch"
                          key={p?.detail_name}
                          draggable
                          onDragStart={() => productDetailsDragStarthandle(p)}
                          onDragOver={productDetailsDragOverhandle}
                          onDrop={() => productDetailshandleDrop(p)}
                        >
                          <div className="flex items-center gap-1">
                            <img
                              src={DragAndDropIcon}
                              alt="Drag And Drop Icon"
                              style={{ cursor: "pointer" }}
                            />
                            <div
                              className=""
                              style={{
                                fontFamily: "Inter",
                                paddingLeft: "5px",
                                color: "#1C1C1E",
                                fontSize: "12px",
                                fontWeight: p?.toggle ? 600 : 400,
                                lineHeight: "18px",
                              }}
                            >
                              {p?.detail_name}
                            </div>
                          </div>
                          <Switch
                            checked={p?.toggle}
                            onChange={(event) =>
                              ProductDetailSwitchChangeHandler(p?.id)
                            }
                          />
                        </div>
                      ))}
                  </div>
                )}
              </div>

              {/* Parameters */}
              <div
                className="flex flex-col items-start gap-4 self-stretch rounded-[4px]"
                style={{
                  border: "1px solid #EAEAED",
                }}
              >
                <div
                  className="flex items-start self-stretch rounded-[4px] cursor-pointer"
                  style={{
                    borderBottom:
                      drawerSubOption === "PARAMETERS"
                        ? "1px solid #EAEAED"
                        : "0px",
                  }}
                  onClick={() => {
                    if (drawerSubOption === "PARAMETERS") {
                      setDrawerSubOption("");
                    } else {
                      setDrawerSubOption("PARAMETERS");
                    }
                  }}
                >
                  <div className="flex h-[44px] w-full justify-between px-4 py-2 items-center gap-2 ">
                    <div
                      style={{
                        color: "var(--Text-Primary-Black, #1C1C1E)",
                        fontFamily: "Inter",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "10px", // 100%
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      Parameters
                    </div>
                    {drawerSubOption === "PARAMETERS" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M6.83366 11.6667C6.70866 11.6667 6.60796 11.625 6.53158 11.5417C6.45519 11.4583 6.41699 11.3611 6.41699 11.25C6.41699 11.2222 6.45866 11.125 6.54199 10.9583L9.56283 7.9375C9.63227 7.86806 9.70171 7.81944 9.77116 7.79167C9.8406 7.76389 9.91699 7.75 10.0003 7.75C10.0837 7.75 10.16 7.76389 10.2295 7.79167C10.2989 7.81944 10.3684 7.86806 10.4378 7.9375L13.4587 10.9583C13.5003 11 13.5316 11.0451 13.5524 11.0938C13.5732 11.1424 13.5837 11.1944 13.5837 11.25C13.5837 11.3611 13.5455 11.4583 13.4691 11.5417C13.3927 11.625 13.292 11.6667 13.167 11.6667H6.83366Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.56234 12.0625L6.5415 9.04167C6.49984 9 6.46859 8.95486 6.44775 8.90625C6.42692 8.85764 6.4165 8.80556 6.4165 8.75C6.4165 8.63889 6.4547 8.54167 6.53109 8.45834C6.60748 8.375 6.70817 8.33334 6.83317 8.33334H13.1665C13.2915 8.33334 13.3922 8.375 13.4686 8.45834C13.545 8.54167 13.5832 8.63889 13.5832 8.75C13.5832 8.77778 13.5415 8.875 13.4582 9.04167L10.4373 12.0625C10.3679 12.1319 10.2984 12.1806 10.229 12.2083C10.1596 12.2361 10.0832 12.25 9.99984 12.25C9.9165 12.25 9.84012 12.2361 9.77067 12.2083C9.70123 12.1806 9.63178 12.1319 9.56234 12.0625Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                    )}
                  </div>
                </div>
                {drawerSubOption === "PARAMETERS" && (
                  <div className="flex flex-col items-start self-stretch">
                    {parametersDataDrawer.length > 0 &&
                      parametersDataDrawer.map((p: Parameter) => (
                        <div
                          className="flex justify-between items-center h-[40px] p-4 gap-2 self-stretch"
                          key={p?.parameter_name}
                          draggable
                          onDragStart={() => parameterDragStarthandle(p)}
                          onDragOver={parameterDragOverhandle}
                          onDrop={() => parameterhandleDrop(p)}
                        >
                          <div className="flex items-center gap-1">
                            <img
                              src={DragAndDropIcon}
                              alt="Drag And Drop Icon"
                              style={{ cursor: "pointer" }}
                            />
                            <div
                              className=""
                              style={{
                                fontFamily: "Inter",
                                paddingLeft: "5px",
                                color: "#1C1C1E",
                                fontSize: "12px",
                                fontWeight: p?.toggle ? 600 : 400,
                                lineHeight: "18px",
                              }}
                            >
                              {p?.parameter_name}
                            </div>
                          </div>
                          <Switch
                            checked={p?.toggle}
                            onChange={(event) =>
                              ParameterSwitchChangeHandler(p?.id)
                            }
                          />
                        </div>
                      ))}
                  </div>
                )}
              </div>

              {/* Metrices */}
              <div
                className="flex flex-col items-start gap-4 self-stretch rounded-[4px] mb-4"
                style={{
                  border: "1px solid #EAEAED",
                }}
              >
                <div
                  className="flex items-start self-stretch rounded-[4px] cursor-pointer"
                  style={{
                    borderBottom:
                      drawerSubOption === "METRICES"
                        ? "1px solid #EAEAED"
                        : "0px",
                  }}
                  onClick={() => {
                    if (drawerSubOption === "METRICES") {
                      setDrawerSubOption("");
                    } else {
                      setDrawerSubOption("METRICES");
                    }
                  }}
                >
                  <div className="flex h-[44px] w-full justify-between px-4 py-2 items-center gap-2 ">
                    <div
                      style={{
                        color: "var(--Text-Primary-Black, #1C1C1E)",
                        fontFamily: "Inter",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "10px", // 100%
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      Metrics
                    </div>
                    {drawerSubOption === "METRICES" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M6.83366 11.6667C6.70866 11.6667 6.60796 11.625 6.53158 11.5417C6.45519 11.4583 6.41699 11.3611 6.41699 11.25C6.41699 11.2222 6.45866 11.125 6.54199 10.9583L9.56283 7.9375C9.63227 7.86806 9.70171 7.81944 9.77116 7.79167C9.8406 7.76389 9.91699 7.75 10.0003 7.75C10.0837 7.75 10.16 7.76389 10.2295 7.79167C10.2989 7.81944 10.3684 7.86806 10.4378 7.9375L13.4587 10.9583C13.5003 11 13.5316 11.0451 13.5524 11.0938C13.5732 11.1424 13.5837 11.1944 13.5837 11.25C13.5837 11.3611 13.5455 11.4583 13.4691 11.5417C13.3927 11.625 13.292 11.6667 13.167 11.6667H6.83366Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.56234 12.0625L6.5415 9.04167C6.49984 9 6.46859 8.95486 6.44775 8.90625C6.42692 8.85764 6.4165 8.80556 6.4165 8.75C6.4165 8.63889 6.4547 8.54167 6.53109 8.45834C6.60748 8.375 6.70817 8.33334 6.83317 8.33334H13.1665C13.2915 8.33334 13.3922 8.375 13.4686 8.45834C13.545 8.54167 13.5832 8.63889 13.5832 8.75C13.5832 8.77778 13.5415 8.875 13.4582 9.04167L10.4373 12.0625C10.3679 12.1319 10.2984 12.1806 10.229 12.2083C10.1596 12.2361 10.0832 12.25 9.99984 12.25C9.9165 12.25 9.84012 12.2361 9.77067 12.2083C9.70123 12.1806 9.63178 12.1319 9.56234 12.0625Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                    )}
                  </div>
                </div>
                {drawerSubOption === "METRICES" && (
                  <div className="flex flex-col items-start self-stretch">
                    {matricesDataDrawer.length > 0 &&
                      matricesDataDrawer.map((m: Matrice) => (
                        <div
                          className="flex justify-between items-center h-[40px] p-4 gap-2 self-stretch"
                          key={m?.matrice_name}
                          draggable
                          onDragStart={() => metriceDragStarthandle(m)}
                          onDragOver={metriceDragOverhandle}
                          onDrop={() => metricehandleDrop(m)}
                        >
                          <div className="flex items-center gap-1">
                            <img
                              src={DragAndDropIcon}
                              alt="Drag And Drop Icon"
                              style={{ cursor: "pointer" }}
                            />
                            <div
                              className=""
                              style={{
                                fontFamily: "Inter",
                                paddingLeft: "5px",
                                color: "#1C1C1E",
                                fontSize: "12px",
                                fontWeight: m?.toggle ? 600 : 400,
                                lineHeight: "18px",
                              }}
                            >
                              {m?.matrice_name}
                            </div>
                          </div>
                          <Switch
                            checked={m?.toggle}
                            onChange={(event) =>
                              MatriceSwitchChangeHandler(m?.id)
                            }
                          />
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </DialogContent>
        <div
                  className="h-[68px] w-full p-4 flex gap-6 justify-center items-center"
                  style={{
                    borderTop: "1px solid #EAEAED",
                    backgroundColor: WHITE.W_100,
                  }}
                >
                  <Button
                    sx={{
                      backgroundColor: "#FFF",
                      ":hover": {
                        backgroundColor: "#FFF",
                      },
                      borderRadius: "4px",
                      paddingX: "6px",
                      width: "50%",
                      paddingY: "0px",
                      border: `1px solid #EAEAED`,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontFamily: "inter",
                      fontSize: "12px",
                      fontWeight: 700,
                      lineHeight: "18px",
                      color: resetToggle ? "#1C1C1E" : "#B7B7B9",
                      '&.Mui-disabled': {
                                        backgroundColor: 'white',  // Change this to the desired color
                                        color: "#B7B7B9"
                                      },
                    }}
                    onClick={onResetColumnsHandler}
                    disabled={!resetToggle}
                  >
                    Reset Columns
                  </Button>
        
                  <Button
                    onClick={columnsApply}
                    sx={{
                      height: "36px",
                      width: "50%",
                      backgroundColor: "#1565C0",
                      color: "#FFF",
                      borderRadius: "4px",
                      padding: "0px 6px",
                      fontSize: "12px",
                      fontWeight: 700,
                      lineHeight: "18px",
                    }}
                    loading={loading}
                  >
                    Apply
                  </Button>
                </div>
      </Drawer>

      {confirmConditionToggle && (
        <ConfirmConditionModal
          setConfirmConditionToggle={setConfirmConditionToggle}
          setCreateNewCond={setCreateNewCond}
          local_Cond_name={local_Cond_name}
          setlocal_Cond_name={setlocal_Cond_name}
          local_Cond_id={local_Cond_id}
          localConditionsArr={localconditions}
          newConditionsArr={newconditionsArr}
          fetchConditionsData={fetchConditionsData}
          ClearAll={ClearAll}
          setConditionsArr={setConditionsArr}
          setConditionToggle={setConditionToggle}
          isDbDataChanges={isDbDataChanges}
          setIsDbDataChanges={setIsDbDataChanges}
          page_name="ADS_PLACEMENT_ANALYSIS_COMPARISON"
        />
      )}

      {createNewCond && (
        <CreateNewConditionModal
          setConfirmConditionToggle={setConfirmConditionToggle}
          localConditionsArr={localconditions}
          newConditionsArr={newconditionsArr}
          setCreateNewCond={setCreateNewCond}
          fetchConditionsData={fetchConditionsData}
          ClearAll={ClearAll}
          listarr={listarr}
          page_name="ADS_PLACEMENT_ANALYSIS_COMPARISON"
        />
      )}

      {exportSelectionToggle && (
        <ComparisonExportSelectionModal
          setToggle={setExportSelectionToggle}
          parametersData={parametersData}
          exportfunc={exportHandler}
          loading={exportLoading}
        />
      )}

      {customExportToggle && (
        <ComparisonCustomExportModal
          setToggle={setCustomExportToggle}
          ip_maxminRange={range}
          ip_Range={InputRange}
          productDetailsData={productDetails}
          parametersData={parametersData}
          matricesData={matricesData}
          exportfunc={exportCustomHandler}
          loading={exportLoading}
        />
      )}
  
    </>
  );
};

export default PlacementAnalysisComparison;
